{
  "auth": {
    "login": "Login",
    "logout": "Logout",
    "loginTitle": "Welcome back",
    "loginSubtitle": "Sign in with your username or email and panel password",
    "loginIdentifier": "Username or email",
    "loginIdentifierPlaceholder": "admin or you{'@'}example.com",
    "systemDescription": "Modern and efficient SSH/V2Ray account management system",
    "email": "Email",
    "emailPlaceholder": "you{'@'}example.com",
    "username": "Username",
    "password": "Password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "forgotPasswordTitle": "Recover password",
    "forgotPasswordSubtitle": "Enter the email registered on the panel. We will send a link to reset your password.",
    "forgotPasswordSubmit": "Send link",
    "forgotPasswordSent": "If the email is registered, you will receive instructions shortly. Check spam too.",
    "forgotPasswordError": "Could not process the request. Try again.",
    "backToLogin": "Back to login",
    "resetPasswordTitle": "New password",
    "resetPasswordSubtitle": "Set a new password for {username}",
    "resetPasswordNew": "New password",
    "resetPasswordConfirm": "Confirm password",
    "resetPasswordSubmit": "Reset password",
    "resetPasswordSuccess": "Password reset successfully. Sign in with your new password.",
    "resetPasswordInvalidToken": "Invalid or expired link. Request a new password reset.",
    "resetPasswordMismatch": "Passwords do not match",
    "resetPasswordError": "Could not reset password",
    "passwordRequirements": "At least 6 characters with uppercase, lowercase and a number.",
    "loginButton": "Sign In",
    "loggingIn": "Signing in...",
    "loginSuccess": "Login successful!",
    "loginError": "Login error",
    "invalidCredentials": "Invalid username or password",
    "tooManyAttempts": "Too many login attempts. Try again in a few minutes.",
    "sessionExpired": "Session expired. Please login again.",
    "contactAdmin": "Contact the administrator to recover your password",
    "impersonate": {
      "banner": "Viewing as: {username} ({role})",
      "stopAdmin": "Back to Admin",
      "stopReseller": "Back to my account"
    },
    "passwordPlaceholder": "Enter your password",
    "sessionExpiration": {
      "title": "Session expiring",
      "message": "Your session will expire due to inactivity soon. Click \"Stay connected\" to remain signed in.",
      "timeRemaining": "Inactivity time remaining",
      "tip": "Click \"Stay connected\" to renew now.",
      "logoutNow": "Log out now",
      "extending": "Renewing...",
      "stayConnected": "Stay connected",
      "refreshFailed": "Could not renew your session. Please sign in again or try once more."
    }
  },
  "accounts": {
    "title": "Manage Accounts",
    "subtitle": "Manage all SSH and V2Ray accounts",
    "createTest": "Create Test",
    "createAccount": "Create Account",
    "createTestShort": "Test",
    "createAccountShort": "New account",
    "deleteSelectedShort": "Delete",
    "selectAll": "Select All",
    "deleteSelected": "Delete Selected",
    "totalAccounts": "Total Accounts",
    "activeAccounts": "Active Accounts",
    "expiredAccounts": "Expired Accounts",
    "testAccounts": "Test Accounts",
    "searchPlaceholder": "Search by username or UUID...",
    "allTypes": "All types",
    "onlySSH": "SSH only",
    "onlyV2Ray": "V2Ray only",
    "sshAndV2Ray": "SSH + V2Ray",
    "allStatus": "All statuses",
    "active": "Active",
    "inactive": "Inactive",
    "expired": "Expired",
    "test": "Test",
    "allCreatorTypes": "All types",
    "admins": "Admins",
    "resellersFilter": "Resellers",
    "allOnline": "All",
    "onlyOnline": "Online only",
    "onlyOffline": "Offline only",
    "allExpiration": "All expiration",
    "expiringWithinDays": "Expires within {days} days",
    "expirationSortDefault": "Default order",
    "expirationSortAsc": "Expiration: soonest first",
    "expirationSortDesc": "Expiration: latest first",
    "specificCreator": "Specific creator",
    "searchCreator": "Search creator...",
    "noCreatorsFound": "No creators found",
    "allCreators": "All creators",
    "roleSuperAdmin": "Super Admin",
    "roleAdmin": "Admin",
    "roleReseller": "Reseller",
    "accounts_count": "accounts",
    "username": "Username",
    "category": "Category",
    "type": "Type",
    "connections": "Connections",
    "expiration": "Expiration",
    "status": "Status",
    "actions": "Actions",
    "noAccountsFound": "No accounts found",
    "expires": "Expires",
    "expiresIn": "Expires in {time}",
    "expiresTomorrow": "Expires tomorrow",
    "expiresInDays": "{days}d remaining",
    "expiresInHours": "{hours}h remaining",
    "ssh": "SSH",
    "v2ray": "V2Ray",
    "combo": "SSH + V2Ray",
    "enable": "Enable",
    "disable": "Disable",
    "edit": "Edit",
    "renew": "Renew",
    "clearDevices": "Clear Devices",
    "delete": "Delete",
    "deleteConfirm": {
      "titleOne": "Delete account?",
      "titleMany": "Delete {count} account(s)?",
      "warning": "WARNING! This action is IRREVERSIBLE!",
      "questionOne": "Do you really want to DELETE account \"{username}\"?",
      "questionMany": "Do you really want to DELETE {count} account(s)?",
      "moreCount": " and {count} more",
      "bulletDbOne": "It will be removed from the database",
      "bulletDbMany": "They will be removed from the database",
      "bulletServersOne": "It will be deleted from all servers",
      "bulletServersMany": "They will be deleted from all servers",
      "bulletDevices": "All devices will be cleared",
      "finalWarning": "This action CANNOT be undone!"
    },
    "bulkDeleteModal": {
      "title": "Delete {count} account(s)?",
      "keepOpenHint": "Deletion continues in the background. Please wait until it finishes."
    },
    "createModal": {
      "title": "Create New Account",
      "manual": "Manual",
      "byPlan": "By Plan",
      "selectPlan": "Select a Plan",
      "choosePlan": "Choose a plan",
      "days": "days",
      "selectCategory": "Select a category",
      "servers": "server",
      "serversPlural": "servers",
      "planDetails": "Plan Details",
      "planType": "Type",
      "validity": "Validity",
      "connectionLimit": "Connection Limit",
      "usernameLabel": "Username",
      "usernamePlaceholder": "Username",
      "passwordLabel": "Password",
      "passwordHelp": "Minimum 4 characters",
      "passwordPlaceholder": "User password",
      "generateRandom": "Generate random credentials",
      "categoryLabel": "Category",
      "accountType": "Account Type",
      "expirationDays": "Validity Days",
      "daysPlaceholder": "Ex: 30",
      "createButton": "Create Account",
      "creating": "Creating...",
      "summary": "Summary:",
      "summaryType": "Type:",
      "summaryUsername": "Username:",
      "summaryValidity": "Validity:",
      "summaryExpires": "Expires on:",
      "summaryCategory": "Category:",
      "summaryServers": "Will be created on {count} server(s)",
      "usernamePlaceholderManual": "Ex: user123",
      "passwordPlaceholderManual": "Ex: password123",
      "sshOnly": "SSH Only",
      "v2rayOnly": "V2Ray Only",
      "sshV2ray": "SSH + V2Ray",
      "uuidAutoGenerate": "UUID: Will be automatically generated by the system",
      "autoCredentialsInfo": "Automatic Credentials: Username and password will be automatically generated",
      "selectCategoryPlaceholder": "Select a category",
      "selectCategoryError": "Select a category",
      "resellerCredits": "Available credits",
      "resellerSlots": "Available slots",
      "resellerSlotsUsed": "{used} slot(s) in use",
      "emailLabel": "Email",
      "emailPlaceholder": "client{'@'}email.com",
      "whatsappLabel": "WhatsApp",
      "whatsappPlaceholder": "+5511999999999",
      "telegramLabel": "Telegram",
      "telegramPlaceholder": "{'@'}username or ID",
      "categoryInheritedHint": "Category linked to reseller (inherited automatically)",
      "unlimited": "Unlimited",
      "generateUsername": "Generate username",
      "generatePassword": "Generate password",
      "validityDaysRange": "Minimum: {min} days. Maximum: 3650 days (10 years)",
      "buttonTooltips": {
        "saving": "Saving...",
        "selectPlan": "Select a plan",
        "selectCategory": "Select a category",
        "insufficientCredits": "Insufficient credits. Required: {needed}, Available: {available}"
      }
    },
    "testModal": {
      "title": "Create Test Account",
      "categoryLabel": "Category",
      "categoryInherited": "Category inherited from your reseller",
      "serversInCategory": "{count} server(s) in selected category",
      "usernameLabel": "Username",
      "usernameHelp": "3-32 characters, letters and numbers only",
      "passwordLabel": "Password",
      "passwordHelp": "Minimum 4 characters",
      "durationLabel": "Duration (hours)",
      "durationPlaceholder": "Ex: 2",
      "maxDuration": "Maximum: {max} hours",
      "includeV2ray": "Include V2Ray in test",
      "testSummary": "Test Summary:",
      "summaryType": "Type",
      "summaryValidity": "Validity",
      "summaryCategory": "Category",
      "summaryServers": "Will be created on {count} server(s)",
      "hours": "hours",
      "createButton": "Create Test",
      "creating": "Creating...",
      "hour": "hour",
      "usernamePlaceholder": "Ex: test123",
      "passwordPlaceholder": "Ex: password123",
      "generateUsername": "Generate random username",
      "generatePassword": "Generate random password"
    },
    "editAccount": "Edit Account",
    "connectionLimit": "Limit",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "createdBy": "Created by",
    "currentPassword": "Current Password",
    "naV2ray": "N/A (V2Ray)",
    "actionTooltips": {
      "enable": "Enable",
      "disable": "Disable",
      "renewExpired": "Renew to reactivate",
      "renew": "Renew",
      "copyCredentials": "Copy credentials",
      "edit": "Edit",
      "clearDevices": "Clear Devices",
      "delete": "Delete"
    },
    "toggleConfirm": {
      "enableTitle": "Enable account?",
      "disableTitle": "Disable account?",
      "enableMessage": "Do you want to enable account \"{username}\"?",
      "disableMessage": "Do you want to disable account \"{username}\"?"
    },
    "expiryLabels": {
      "expired": "Expired",
      "expiresToday": "Expires today",
      "expiresTomorrow": "Expires tomorrow",
      "expiresInDays": "Expires in {days} days",
      "expiresInHours": "Expires in {hours}h",
      "minutesRemaining": "{minutes} minute(s) remaining",
      "hoursRemaining": "{hours} hour(s) remaining",
      "daysRemaining": "{days} days remaining"
    },
    "clearDevicesConfirm": {
      "title": "Clear Devices?",
      "message": "Clear all registered devices for \"{username}\"?\n\nThis will allow the user to register new devices."
    },
    "editModal": {
      "accountInfo": "Account Information",
      "copyUsername": "Copy username",
      "togglePassword": "Show/hide password",
      "copyPassword": "Copy password",
      "copyUuid": "Copy UUID",
      "uuidNotGenerated": "Not generated",
      "resellerCreditTitle": "Credit Reseller Mode",
      "resellerCreditHint": "You can edit password and WhatsApp. Other fields are read-only.",
      "editFields": "Edit Fields",
      "categoryMigrationHint": "When changing category, the account will be migrated to the new category servers",
      "newPassword": "New Password",
      "passwordKeepPlaceholder": "Leave empty to keep current password",
      "passwordKeepHint": "Leave blank to keep unchanged. Minimum 4 characters if changing.",
      "expirationDate": "Expiration Date",
      "saveChanges": "Save Changes",
      "expiryPastWarning": "Past date — account will be expired",
      "expiryInDays": "Expires in {days} day(s)"
    },
    "renewModal": {
      "title": "Renew Account",
      "accountLabel": "Account:",
      "typeLabel": "Type:",
      "expiresLabel": "Expires:",
      "addDays": "Add Days",
      "addDaysHint": "Add days to current expiration date",
      "addMonths": "Add Validity (months)",
      "monthOption": "{months} month(s) ({days} days) - {credits} credit(s)",
      "addDaysPreview": "Add {days} days to current validity",
      "creditsAvailable": "Available credits:",
      "creditsInsufficientShort": "Insufficient credits!",
      "newExpiryLabel": "New expiration date:",
      "daysAdded": "(+{days} day(s))",
      "creditsSufficient": "Sufficient Credits",
      "creditsInsufficient": "Insufficient Credits!",
      "creditsAvailableLabel": "Available Credits:",
      "creditsNeededLabel": "Credits Required:",
      "balanceAfterRenewal": "Balance After Renewal:",
      "creditsMissing": "Missing {count} credits!",
      "syncWarning": "Warning: Renewal will be automatically synced with all category servers.",
      "renewing": "Renewing...",
      "submit": "Renew Account",
      "insufficientCredits": "Insufficient credits! You have {available}, need {needed}",
      "insufficientCreditsTooltip": "Insufficient credits"
    },
    "resultModal": {
      "title": "Account created successfully",
      "serversCount": "{count} server(s) · {category}",
      "provisioningPendingTitle": "Sync in progress.",
      "provisioningPendingBody": " The account was created in the panel. Servers will be updated in the background — if any is offline, the administrator will be notified.",
      "validityDays": "{days} days",
      "validityLabel": "Validity",
      "expiresAtLabel": "Expires on",
      "categoryLabel": "Category",
      "serversLabel": "Servers",
      "planLabel": "Plan",
      "connectionLimitLabel": "Connection limit",
      "connectionLimitValue": "{limit} device(s)",
      "createdModePlan": "By plan",
      "createdModeManual": "Manual",
      "copyHint": "Copy the details below or send a ready-made message via WhatsApp/Telegram."
    },
    "testResultModal": {
      "title": "Test account created",
      "badge": "Test account",
      "validityHours": "{hours} hour(s)"
    },
    "deletePlanModal": {
      "title": "Delete Plan",
      "question": "Are you sure you want to delete the plan",
      "cannotUndo": "This action cannot be undone."
    }
  },
  "servers": {
    "title": "Manage Servers",
    "addServer": "Add Server",
    "addServerShort": "Server",
    "editServer": "Edit Server",
    "deleteServer": "Delete Server",
    "serverName": "Server Name",
    "host": "Host/IP",
    "sshPort": "SSH Port",
    "sshUser": "SSH User",
    "sshPassword": "SSH Password",
    "userLimit": "User Limit",
    "category": "Category",
    "installAPI": "Install API",
    "uninstallAPI": "Uninstall API",
    "checkStatus": "Check Status",
    "apiInstalled": "API Installed",
    "apiNotInstalled": "API Not Installed",
    "apiError": "API Error",
    "testConnection": "Test Connection",
    "connectionSuccess": "Connection successful!",
    "connectionFailed": "Connection failed",
    "serverCreated": "Server created successfully!",
    "serverUpdated": "Server updated successfully!",
    "serverDeleted": "Server deleted successfully!",
    "confirmDelete": "Are you sure you want to delete this server?",
    "subtitle": "Manage all SSH and V2Ray servers",
    "totalServers": "Total Servers",
    "activeServers": "Active Servers",
    "installedApis": "Installed APIs",
    "cpuCores": "{count} cores",
    "reinstallApi": "Reinstall API",
    "edit": "Edit",
    "syncLabel": "Sync",
    "noServersFound": "No servers found",
    "sync": {
      "syncing": "Syncing...",
      "startedTitle": "Sync started",
      "startedMessage": "Sync for «{name}» has started. You will be notified when it finishes.",
      "completedTitle": "Sync completed",
      "completedWithErrorsTitle": "Sync completed with errors",
      "completedPartialTitle": "Sync completed with caveats",
      "errorTitle": "Sync error",
      "errorGeneric": "Could not sync the server",
      "startFailed": "Could not start sync",
      "startUncertain": "The request timed out, but sync may have started. Wait for the notification bell.",
      "startFailedTitle": "Sync error",
      "slowTitle": "Sync taking longer",
      "slowMessage": "Sync is still running. Check notifications shortly.",
      "notificationBody": "Server «{server}»: {summary}",
      "notificationFailed": "Server «{server}»: {error}",
      "bellCompleted": "Sync completed",
      "bellPartial": "Sync completed with caveats",
      "bellWithErrors": "Sync completed with errors",
      "bellError": "Sync error",
      "resultEligible": "📤 {count} sent to API",
      "resultAccountsProcessed": "📋 {count} account(s) processed",
      "resultSshSent": "🔐 {count} SSH to API",
      "resultV2raySent": "📡 {count} V2Ray to API",
      "resultNoneEligible": "No active eligible accounts to sync",
      "resultSynced": "✅ {count} OK (all protocols)",
      "resultPartial": "⚠️ {count} partial (SSH or V2Ray)",
      "resultPartialOk": "✓ {count} OK on some protocols",
      "resultApiRejected": "❌ {count} rejected by API",
      "resultSkippedHeader": "Skipped: {list}",
      "resultCategoryTotal": "📊 {count} in category",
      "resultExpired": "⏰ {count} expired",
      "resultInactive": "🔒 {count} inactive",
      "resultInvalid": "⚠️ {count} invalid credentials",
      "resultReseller": "🚫 {count} inactive/expired reseller",
      "resultFailed": "❌ {count} failed",
      "resultTotal": "📊 Total: {count}",
      "summaryEligible": "{count} sent to API",
      "summaryAccountsProcessed": "{count} account(s) processed",
      "summarySshSent": "{count} SSH to API",
      "summaryV2raySent": "{count} V2Ray to API",
      "summaryOutcome": "result: {list}",
      "summaryApiOkTotal": "{count} OK ({ssh} SSH + {v2ray} V2Ray)",
      "summaryApiRejectedTotal": "{count} rejected by API",
      "resultAccountsSynced": "✅ {count} account(s) synced",
      "resultAccountsFailed": "❌ {count} account(s) failed",
      "summarySynced": "{count} OK",
      "summaryPartial": "{count} partial",
      "summaryPartialOk": "{count} partial OK",
      "summaryApiRejected": "{count} API rejected",
      "summarySkipped": "skipped: {list}",
      "summaryCategoryTotal": "{count} in category",
      "summaryExpired": "{count} expired skipped",
      "summaryInactive": "{count} inactive skipped",
      "summaryInvalid": "{count} invalid credentials",
      "summaryReseller": "{count} inactive/expired reseller",
      "summaryFailed": "{count} total API failure(s)",
      "summaryTotal": "total {count}"
    },
    "installProgress": {
      "modalTitle": "Installing API on Server",
      "progressLabel": "Progress",
      "cancel": "Cancel",
      "close": "Close",
      "connectingSsh": "Connecting to SSH server...",
      "logStarting": "Starting API installation...",
      "logConnecting": "Connecting via SSH...",
      "installSuccess": "API installed successfully!",
      "adoptedSuccess": "Existing API linked and binary updated!",
      "failedToast": "API installation failed. Check the logs.",
      "sshAuthFailed": "SSH authentication failed. Check the server username and password.",
      "sshConnectionFailed": "Could not connect to the server. Check host, SSH port, and firewall.",
      "completedMessage": "Installation completed successfully!",
      "apiRespondingOnPort": "API responding on port {port}",
      "waiting_start": "Waiting to start...",
      "checking_existing": "Checking for existing installation...",
      "existing_detected": "Existing API detected — preserving key, port {port}, and updating binary only",
      "services_stopped": "Previous service(s) stopped: {names}",
      "detecting_architecture": "Detecting architecture...",
      "binary_selected": "Binary: {binaryName} (GitHub Releases)",
      "creating_directories": "Creating directories...",
      "downloading_binary": "Downloading binary from GitHub (panel)...",
      "uploading_binary": "Uploading binary to server via SFTP...",
      "binary_downloaded": "Binary deployed ({sizeMb} MB)",
      "binary_path_resolved": "Server binary path: {path}",
      "binary_deployed": "Binary replaced at {path} ({sizeMb} MB)",
      "binary_upload_failed": "Failed to upload binary to the server via SFTP.",
      "binary_upload_size_mismatch": "Incomplete binary upload (local: {local} bytes, remote: {remote} bytes).",
      "keeping_systemd": "Keeping existing systemd unit (key and port preserved)",
      "configuring_systemd": "Configuring systemd...",
      "reloading_systemd": "Reloading systemd...",
      "enabling_service": "Enabling service...",
      "starting_service": "Starting service...",
      "checking_status": "Checking status...",
      "service_active": "VeltrixPanel service is active!",
      "testing_api": "Testing API...",
      "api_responding": "API responding (HTTP 200)",
      "completed": "Installation completed!",
      "existing_service_detected": "Existing installation detected (VeltrixPanel.service)",
      "existing_key_reused": "Existing key will be reused to keep compatibility with other panels",
      "existing_port_reused": "Existing port will be reused: {port}",
      "existing_port_not_found": "Existing installation detected, but the port could not be read from the systemd service",
      "services_stopped_ok": "Previous service(s) stopped",
      "arch_detected": "Architecture detected: {arch}",
      "systemd_preserved": "Systemd configuration kept — binary only updated",
      "unsupported_architecture": "Unsupported architecture: {arch}",
      "binary_download_failed": "Failed to download binary from GitHub (size: {fileSize} bytes). Check the panel's internet connection.",
      "service_not_started": "Service did not start (status: {status})",
      "exception": "Error: {message}"
    },
    "noServers": "No servers",
    "noServersHint": "Add your first server to get started",
    "loadingMetrics": "Loading metrics...",
    "online": "Online",
    "offline": "Offline",
    "viewOnlineUsers": "View online",
    "onlineUsersModal": {
      "title": "Online users — {name}",
      "subtitle": "Live list from Sentinel API (/users/online)",
      "refresh": "Refresh",
      "loading": "Loading online users...",
      "loadError": "Could not load online users for this server.",
      "empty": "No users online at the moment.",
      "total": "Total: {count}",
      "sshSection": "SSH",
      "v2raySection": "V2Ray",
      "protoSection": "DT-Proto",
      "username": "Username",
      "email": "Email",
      "uuid": "UUID",
      "lastConnection": "Last connection",
      "id": "ID"
    },
    "installApi": "Install API",
    "installRestricted": "Installation restricted to Super Admin",
    "installRestrictedShort": "Restricted",
    "creating": "Creating...",
    "editServerTitle": "Edit Server",
    "editServerSubtitle": "Update server information for {name}",
    "newSshPassword": "New SSH Password (leave blank to keep current)",
    "newSshPasswordPlaceholder": "Enter new SSH password (optional)",
    "defaultCategory": "Default",
    "noCategoriesWarning": "No categories registered. Using default category.",
    "addServerButton": "Add Server",
    "ssh2ExtensionError": "SSH2 extension is not installed.\n\n{instructions}\n\n{note}",
    "deleteModal": {
      "title": "Delete Server",
      "confirm": "Are you sure you want to delete server {name}?",
      "irreversible": "⚠️ This action cannot be undone!",
      "uninstallApiLabel": "Uninstall API from server before deleting",
      "uninstallApiHelp": "Recommended: Removes the API service from the remote server. Uncheck only if you no longer have SSH access to the server.",
      "confirmButton": "Yes, Delete Server"
    },
    "installModal": {
      "title": "Install API {panelName}",
      "subtitle": "Configure API installation on server {name}",
      "apiPortLabel": "API Port",
      "autoKeyTitle": "Automatic API Key",
      "autoKeyHelp": "The API Key will be generated automatically during installation and configured on the server. You can view it after completion.",
      "installing": "Installing..."
    },
    "apiUninstallConfirm": "Are you sure you want to uninstall the API from server \"{name}\"?\n\nThis will stop the {panelName} API service on the remote server."
  },
  "categories": {
    "title": "Categories",
    "subtitle": "Organize your servers into categories",
    "addCategory": "New Category",
    "addCategoryShort": "Category",
    "name": "Name",
    "servers": "Servers",
    "accounts": "Accounts",
    "actions": "Actions",
    "noCategoriesFound": "No categories found",
    "emptyHint": "Create your first category to organize servers and users",
    "defaultBadge": "Default",
    "users": "Users",
    "setAsDefault": "Set as Default",
    "migrate": "Migrate",
    "migrateFrom": "Migrate from: {name}",
    "migrateType": "Type",
    "migrateEntityUsers": "Users",
    "migrateEntityServers": "Servers",
    "migrateEntityResellers": "Resellers",
    "migrateTargetCategory": "Target Category",
    "migrateAttention": "Attention!",
    "migrating": "Migrating...",
    "confirmMigration": "Confirm Migration",
    "cannotDeleteDefault": "Cannot delete the default category",
    "deleteConfirm": {
      "title": "Delete category?",
      "question": "Are you sure you want to delete the category \"{name}\"?",
      "finalWarning": "This action cannot be undone."
    },
    "migrateWarnings": {
      "users": "Accounts in this category will be moved. Accounts linked to resellers will also move the reseller, sub-resellers, hierarchy accounts, and server provisioning.",
      "resellers": "Resellers in this category will be moved together with sub-resellers, hierarchy accounts, and server provisioning.",
      "servers": "All servers in this category will be moved to the selected category."
    }
  },
  "checkuser": {
    "title": "CheckUser",
    "subtitle": "Manage CheckUser for DTunnel and Conecta4G",
    "dtunnelUrl": "DTunnel URL",
    "conectaUrl": "Conecta4G URL",
    "devicePolicyCardTitle": "Devices (DTunnel)",
    "devicePolicyCardSubtitle": "Per-account limit and record cleanup in one place.",
    "deviceLimitTitle": "Device limiter",
    "deviceLimitDesc": "When enabled, checkuser registers each deviceId and returns count_connections (device total). The DTunnel app compares it to limit_connections and enforces the limit.",
    "deviceLimitOffHint": "When off, checkuser ignores deviceId (no storage) and returns count_connections = 0 so the app does not count devices from the server.",
    "cleanupSectionTitle": "Automatic cleanup",
    "cleanupSectionSubtitle": "The worker removes inactive records according to the interval below.",
    "cleanupTotalTitle": "Full reset",
    "cleanupTotalDesc": "Removes all devices for all users. Use only if you understand the impact.",
    "inactivityLabel": "Inactivity period",
    "inactivityHelp": "Records with no access for longer than this are eligible for removal (automatic or manual cleanup).",
    "howItWorksTitle": "How it works",
    "howItWorksBullet1": "The background worker checks periodically.",
    "howItWorksBullet2": "Devices with no access within the configured window may be removed.",
    "howItWorksBullet3": "Frees space and allows new registrations.",
    "howItWorksBullet4": "Normally active accounts in use are not affected by the chosen interval.",
    "statsTotalDevices": "Total devices",
    "statsUsersWithDevices": "Users with devices",
    "statsActive24h": "Active (24h)",
    "statsUsersAtLimit": "At limit",
    "lastAutoCleanup": "Last automatic cleanup",
    "lastAutoCleanupNever": "Not recorded yet",
    "runCleanupNow": "Run Now",
    "runCleanupRunning": "Running…",
    "interval1h": "1 hour",
    "interval2h": "2 hours",
    "interval6h": "6 hours",
    "interval12h": "12 hours",
    "interval24h": "24 hours (1 day)",
    "interval48h": "48 hours (2 days)",
    "interval7d": "7 days (1 week)",
    "deviceCleanup": "Device Cleanup",
    "cleanupInterval": "Cleanup Interval",
    "executeNow": "Execute Now",
    "clearAll": "Clear All",
    "copyUrl": "Copy URL",
    "test": "Test",
    "testing": "Testing...",
    "minutes": "minutes",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "autoCleanup": "Automatic cleanup runs in background every {minutes} minutes",
    "confirmClearAll": "Clear ALL Devices?",
    "confirmClearAllDesc": "This action will clear ALL devices from ALL users. This operation CANNOT be undone!"
  },
  "backup": {
    "title": "Manage Backup",
    "subtitle": "Configure automatic backups via Telegram",
    "telegramBot": "Telegram Bot",
    "botToken": "Bot Token",
    "chatId": "Chat ID",
    "backupPassword": "Backup Password",
    "interval": "Interval",
    "lastBackup": "Last Backup",
    "executeNow": "Backup Now",
    "restoreBackup": "Restore Backup",
    "automaticBackup": "Automatic Backup",
    "restoreTab": "Restore Backup",
    "telegramConfig": "Telegram Configuration",
    "botTokenPlaceholder": "1234567890:ABCdefGHIjklMNOpqrsTUVwxyz",
    "chatIdPlaceholder": "123456789",
    "backupPasswordPlaceholder": "Password to encrypt the backup",
    "backupInterval": "Backup Interval",
    "selectInterval": "Select interval",
    "everyHour": "Every 1 hour",
    "every6Hours": "Every 6 hours",
    "every12Hours": "Every 12 hours",
    "daily": "Daily",
    "saveConfig": "Save Configuration",
    "uploadBackup": "Upload Backup File",
    "selectFile": "Select .sql.enc file",
    "restoreButton": "Restore Database",
    "telegramBackupDesc": "Send encrypted database backups to Telegram",
    "botTokenLabel": "Bot Token",
    "createBotHelp": "Create a bot with",
    "intervalLabel": "Backup Interval",
    "interval1min": "Every 1 minute (TEST)",
    "interval5min": "Every 5 minutes",
    "interval15min": "Every 15 minutes",
    "interval30min": "Every 30 minutes",
    "interval1hour": "Every 1 hour",
    "interval6hours": "Every 6 hours",
    "interval12hours": "Every 12 hours",
    "intervalDaily": "Daily (24h)",
    "interval2days": "Every 2 days",
    "intervalWeekly": "Weekly (7 days)",
    "intervalHelp": "Values in minutes. Worker checks automatically and runs at the configured interval.",
    "chatIdHelp": "Use {'@'}userinfobot to get your Chat ID",
    "passwordNewPlaceholder": "Enter new password or leave blank to keep current",
    "passwordInitialPlaceholder": "Set an encryption password (minimum 8 characters)",
    "passwordConfiguredStatus": "Backup password configured",
    "passwordNotConfiguredStatus": "Configure a backup password",
    "passwordHelpConfigured": "Leave blank to keep current password. Minimum 8 characters if changing.",
    "passwordHelpRequired": "Password required for backup encryption. Keep it safe!",
    "lastAutomaticBackup": "Last Automatic Backup",
    "nextBackupIn": "Next in ~{minutes} min",
    "howItWorksTitle": "How it works:",
    "howItWorksItem1": "Background worker runs automatically",
    "howItWorksItem2": "Database is encrypted with AES-256",
    "howItWorksItem3": "Backup sent to Telegram",
    "howItWorksItem4": "Keep your password to restore",
    "saveSettings": "Save Settings",
    "manualBackupTitle": "Backup manually now",
    "manualBackupDisabledTitle": "Configure backup password first",
    "restoreSubtitle": "Restore an encrypted database backup",
    "selectFileButton": "Select File",
    "criticalOperationTitle": "⚠️ ATTENTION - CRITICAL OPERATION",
    "criticalOperationItem1": "This operation WILL DELETE all current data",
    "criticalOperationItem2": "Make a current backup before restoring",
    "criticalOperationItem3": "Make sure you have the correct file",
    "criticalOperationItem4": "System will be unavailable during restore",
    "criticalOperationItem5": "You will be logged out after restore",
    "restoreProgressTitle": "Restoring backup...",
    "restoreProgressWait": "Please wait. This may take a few minutes. Do not close this page.",
    "confirmRestoreCheckbox": "I understand this operation will DELETE ALL CURRENT DATA and replace it with the backup. I confirm I made a backup of the current database and wish to proceed."
  },
  "logs": {
    "title": "System Logs",
    "subtitle": "History of panel actions and events",
    "level": "Level",
    "message": "Message",
    "date": "Date/Time",
    "action": "Action",
    "user": "User",
    "ip": "IP",
    "clearAll": "Clear All",
    "clearAllShort": "Clear",
    "refresh": "Refresh",
    "totalLogs": "Total Logs",
    "last24h": "Last 24 hours",
    "errors": "Errors",
    "warnings": "Warnings",
    "info": "Info",
    "filterByLevel": "Filter by level",
    "allLevels": "All levels",
    "allActions": "All actions",
    "allEntities": "All entities",
    "dateFrom": "Start date",
    "dateTo": "End date",
    "clickToViewDetails": "Click to view details",
    "detailModal": {
      "title": "Log details",
      "logId": "Record ID",
      "entity": "Entity",
      "userAgent": "User-Agent",
      "oldValues": "Previous values",
      "newValues": "New values",
      "rawDescription": "Raw description",
      "loadError": "Failed to load log details"
    },
    "error": "Error",
    "warning": "Warning",
    "searchLogs": "Search in logs...",
    "noLogsFound": "No logs found",
    "loading": "Loading...",
    "recordsTitle": "Log records",
    "showingRecords": "Showing {shown} of {total} records",
    "lastNLogs": "Last {limit} logs",
    "records50": "50 records",
    "records100": "100 records",
    "records200": "200 records",
    "records500": "500 records",
    "systemUser": "System",
    "confirmClearTitle": "Clear all logs",
    "confirmClearBody": "Remove ALL log records? This action cannot be undone.",
    "details": "Details",
    "confirmClearOld": "Clear logs older than 90 days?"
  },
  "imageCrop": {
    "title": "Crop image",
    "subtitle": "Adjust the framing. Output: {width}×{height}px",
    "confirm": "Use crop",
    "processing": "Processing..."
  },
  "profile": {
    "title": "My Profile",
    "subtitle": "Manage your personal information",
    "avatarTitle": "Profile Photo",
    "choosePhoto": "Choose Photo",
    "uploading": "Uploading...",
    "avatarFormatsHint": "Formats: JPG, PNG • Up to {max} MB when selecting • Auto crop & compress (512×512)",
    "cropAvatarTitle": "Crop profile photo",
    "usernameReadonlyHint": "Username cannot be changed",
    "emailReadonlyHint": "Email cannot be changed",
    "role": "Role",
    "notAvailable": "N/A",
    "removeAvatarTitle": "Remove profile photo?",
    "changePassword": "Change Password",
    "currentPassword": "Current Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm Password",
    "confirmNewPassword": "Confirm New Password",
    "currentPasswordPlaceholder": "Enter your current password",
    "newPasswordPlaceholder": "Enter your new password",
    "confirmPasswordPlaceholder": "Confirm your new password",
    "roles": {
      "super_admin": "Super Administrator",
      "admin": "Administrator",
      "reseller": "Reseller"
    }
  },
  "accountPlans": {
    "title": "Account Plans",
    "subtitle": "Manage available account plans",
    "addPlan": "New Plan",
    "addPlanShort": "Plan",
    "editPlan": "Edit Plan",
    "name": "Plan Name",
    "type": "Type",
    "sshOnly": "SSH Only",
    "v2rayOnly": "V2Ray Only",
    "both": "SSH + V2Ray",
    "validity": "Validity (days)",
    "validityMonths": "Validity (months)",
    "connectionLimit": "Connection Limit",
    "price": "Price",
    "actions": "Actions",
    "noPlansFound": "No plans found",
    "createFirstPlan": "Create first plan",
    "modalTitle": "New Account Plan",
    "modalEditTitle": "Edit Account Plan",
    "namePlaceholder": "Ex: Premium 30 days Plan",
    "description": "Description",
    "descriptionPlaceholder": "Plan description (optional)",
    "selectType": "Select type",
    "validityPlaceholder": "Ex: 30",
    "connectionLimitPlaceholder": "Ex: 1",
    "connectionLimitMinHelp": "Minimum: 1 simultaneous connection",
    "planActive": "Active plan",
    "pricePlaceholder": "Ex: 15.00",
    "createButton": "Create Plan",
    "saveButton": "Save Changes"
  },
  "resellerPlans": {
    "title": "Reseller Plans",
    "subtitle": "Manage reseller plans",
    "addPlan": "New Plan",
    "addPlanShort": "Plan",
    "editPlan": "Edit Plan",
    "name": "Plan Name",
    "credit": "Credit",
    "subscriptionLimit": "Subscription Limit",
    "connectionLimit": "Connection Limit",
    "validity": "Validity (days)",
    "price": "Price",
    "actions": "Actions",
    "noPlansFound": "No plans found",
    "modalTitle": "New Reseller Plan",
    "modalEditTitle": "Edit Reseller Plan",
    "namePlaceholder": "Ex: Premium Reseller Plan",
    "description": "Description",
    "descriptionPlaceholder": "Plan description (optional)",
    "creditAmount": "Credit Amount",
    "creditPlaceholder": "Ex: 100",
    "subscriptionLimitPlaceholder": "Ex: 50",
    "connectionLimitPlaceholder": "Ex: 1",
    "validityPlaceholder": "Ex: 30",
    "durationMonths": "Duration (months)",
    "pricePlaceholder": "Ex: 50.00",
    "createButton": "Create Plan",
    "saveButton": "Save Changes",
    "total": "Total",
    "creditPlans": "Credit",
    "subscriptionPlans": "Subscription",
    "credits": "credits",
    "typeCredit": "Credit",
    "typeSubscription": "Subscription",
    "creditType": "Credit",
    "subscriptionType": "Subscription",
    "creditTypeDesc": "Fixed amount",
    "subscriptionTypeDesc": "Subscription limit",
    "blockedCredit": "🔒 Blocked (you are Subscription)",
    "blockedSubscribe": "🔒 Blocked (you are Credit)",
    "loadingInfo": "⏳ Loading information...",
    "creditResellerInfo": "ℹ️ CREDIT type reseller can only create CREDIT plans",
    "subscribeResellerInfo": "ℹ️ SUBSCRIPTION type reseller can only create SUBSCRIPTION plans",
    "noPlansMessage": "No plans registered. Create your first plan!",
    "planActive": "Active plan",
    "durationDays": "Duration (days)",
    "plan": "Plan",
    "type": "Type",
    "details": "Details",
    "loading": "Loading...",
    "noPlansFull": "No plans registered. Create your first plan!",
    "daysLogins": "days / logins",
    "active": "Active",
    "inactive": "Inactive",
    "deletePlanModal": {
      "title": "Delete Plan",
      "question": "Are you sure you want to delete the plan",
      "cannotUndo": "This action cannot be undone."
    }
  },
  "serverModal": {
    "title": "Add Server",
    "editTitle": "Edit Server",
    "subtitle": "Manage all SSH and V2Ray servers",
    "name": "Name",
    "namePlaceholder": "Ex: Main Server",
    "host": "Host/IP",
    "hostPlaceholder": "Ex: 192.168.1.1",
    "hostHelp": "Supports IPv4, IPv6 and hostnames",
    "sshPort": "SSH Port",
    "sshPortPlaceholder": "22",
    "sshUser": "SSH User",
    "sshUserPlaceholder": "root",
    "sshPassword": "SSH Password",
    "sshPasswordPlaceholder": "***",
    "sshPasswordWarning": "Password will be used to connect via SSH and install the API",
    "category": "Category",
    "selectCategory": "Select a category",
    "addCategory": "Add category",
    "setDefault": "Set as default category",
    "defaultHelp": "The default category will be used when no category is specified",
    "apiPort": "API Port",
    "apiPortPlaceholder": "8080",
    "apiPortHelp": "Port where the API will run (1024-65535)",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create Server"
  },
  "categoryModal": {
    "title": "Add Category",
    "editTitle": "Edit Category",
    "name": "Name",
    "namePlaceholder": "Ex: Premium",
    "description": "Description",
    "descriptionPlaceholder": "Category description",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create Category"
  },
  "salesLink": {
    "title": "Your Sales Link",
    "subtitle": "Share with your customers",
    "accountSalesLabel": "SSH/V2Ray Account Sales",
    "accountSalesHelp": "Customers can purchase access plans through this link",
    "resellerSalesLabel": "Reseller Plan Sales",
    "resellerSalesHelp": "New resellers can sign up through this link",
    "renewalLabel": "Credential renewal",
    "renewalHelp": "Customers can renew SSH/V2Ray accounts by entering username or UUID",
    "recoveryLabel": "Credential recovery",
    "recoveryHelp": "Customers can receive username and password by email (when enabled in settings)",
    "linkCopied": "Link copied to clipboard!",
    "copyError": "Error copying link",
    "salesDisabled": "Automatic sales disabled",
    "salesDisabledHelp": "Enable automatic sales in settings to generate your link",
    "publicTestLabel": "Public trials",
    "publicTestHelp": "Link to the free trial page (when enabled)."
  },
  "automations": {
    "title": "Automations",
    "subtitle": "Configure automations and integrations",
    "paymentGateways": "Payment Gateways",
    "addGateway": "Add Gateway",
    "editGateway": "Edit Gateway",
    "provider": "Provider",
    "region": "Region",
    "accessToken": "Access Token",
    "accessTokenEditPlaceholder": "Leave blank to keep the current token",
    "accessTokenEditHint": "For security the token is not shown. Fill in only if you want to replace it.",
    "mpAccessTokenStoredHint": "Access Token already saved. Fill in only if you want to replace it.",
    "webhookSecretEditPlaceholder": "Leave blank to keep the current secret",
    "webhookSecretStoredHint": "Webhook Secret already saved. Fill in only if you want to replace it.",
    "status": "Status",
    "actions": "Actions",
    "noGateways": "No gateway configured",
    "sales": "Automatic Sales",
    "activateSales": "Activate Sales",
    "salesUrl": "Sales URL",
    "resellerSales": "Reseller Sales",
    "activateResellerSales": "Activate Reseller Sales",
    "gateway": "Gateway",
    "selectProvider": "Select...",
    "mercadoPago": "Mercado Pago",
    "asaas": "Asaas",
    "efiBank": "EFI Bank (Efí Pay)",
    "paypal": "PayPal",
    "regionCountry": "Region / Country",
    "cannotChangeProvider": "Cannot change provider after creation",
    "cannotChangeRegion": "Cannot change region after creation",
    "mpCredentials": "Mercado Pago Credentials",
    "publicKey": "Public Key",
    "publicKeyPlaceholder": "APP_USR-...",
    "mpPublicKeyHint": "Public key (Transparent Checkout or Bricks). Required for card payments. Do not paste the Access Token here.",
    "testMode": "Test Mode",
    "testModeHelp": "Enable to use test credentials",
    "managePaymentMethods": "Manage Payment Methods",
    "paymentMethods": "Payment Methods",
    "enabledMethods": "Enabled Methods",
    "selectMethods": "Select the methods you want to accept",
    "managePaymentMethodsDesc": "Manage your payment methods",
    "messageTemplatesTitle": "Message templates",
    "messageTemplatesSubtitle": "Customize account, reseller, test and sales messages. Empty fields inherit from your master.",
    "messageTemplatesInheritanceHint": "Leave blank or use «Restore default» to inherit from master. Only your customizations are saved.",
    "messageTemplatesSaved": "Templates saved successfully!",
    "noGatewaysConfigured": "No payment gateway configured",
    "configureGatewayFirst": "Configure a payment gateway first",
    "salesWarning": "To activate automatic sales and resales, add at least one payment gateway above (Mercado Pago, Asaas, or PayPal).",
    "salesSettingsTitle": "Sales settings",
    "salesCategoryLabel": "Sales category",
    "accountSalesCategoryLabel": "Category for account sales",
    "resellerSalesCategoryLabel": "Category for reseller sales",
    "salesCategoryAdminHelp": "Choose the category used for automatic sales. This applies to both account and reseller sales.",
    "salesCategoryResellerHelp": "The category is inherited from your reseller profile and cannot be changed here.",
    "selectSalesCategory": "Select a category",
    "selectSalesCategoryFirst": "Select a category in this card before enabling.",
    "salesCategorySaved": "Sales category saved successfully",
    "howToConfigure": "📌 How to Configure",
    "mpStep1": "Access: Mercado Pago Developers",
    "mpStep2": "Go to \"Your integrations\" → \"Credentials\"",
    "mpStep3": "Copy the production \"Access Token\" and paste above",
    "mpStep4": "Configure the webhook in Mercado Pago with the provided URL",
    "mpStep5": "Activate desired sales",
    "mpStep6": "Share the public URL with your clients!",
    "setDefaultGateway": "Set as default gateway",
    "defaultGatewayHelp": "Default gateway will be shown first to clients",
    "addFirstGateway": "Add First Gateway",
    "configurePaymentMethods": "Configure Methods",
    "selectPaymentMethodsDesc": "Select which payment methods you want to offer to your customers",
    "methodsSelected": "methods selected",
    "noPaymentMethodsAvailable": "No payment methods available for this region",
    "paymentMethodsUpdated": "Payment methods updated successfully",
    "asaasCredentials": "Asaas Credentials",
    "asaasEnvironment": "Environment",
    "asaasEnvironmentProduction": "Production",
    "asaasEnvironmentSandbox": "Sandbox",
    "asaasEnvironmentHelp": "Sandbox: $aact_hmlg_... key on api-sandbox.asaas.com. Production: $aact_prod_... key on api.asaas.com. Never mix key and environment.",
    "asaasApiKey": "API Key",
    "asaasApiKeyPlaceholder": "paste your Asaas API key ($aact_hmlg_... or $aact_prod_...)",
    "asaasApiKeyEditPlaceholder": "leave blank to keep the current key",
    "asaasApiKeyHelp": "Generate it in Asaas → Integrations → API. Do not paste the panel webhook URL here.",
    "asaasApiKeyStoredHint": "API key already saved. Fill in only if you want to replace it.",
    "asaasWebhookToken": "Webhook Token",
    "asaasWebhookTokenPlaceholder": "optional, set the same token in Asaas",
    "asaasWebhookTokenHelp": "Use this token to validate webhook calls sent by Asaas.",
    "asaasWebhookDescription": "Configure this URL in Asaas → My account → Integrations → Webhooks to receive payment notifications.",
    "asaasWebhookTokenRequiredHint": "In Asaas, set the same token above as «Authentication token». Asaas sends it in the asaas-access-token header. Use a public URL (ngrok/domain) — localhost cannot receive webhooks.",
    "pixEvpKey": "PIX Key (EVP)",
    "pixEvpKeyPlaceholder": "e.g. 123e4567-e89b-12d3-a456-426614174000",
    "pixEvpKeyHelp": "Register this EVP key in the Asaas dashboard (Pix → Keys). API v3 does not send the key per charge; it must exist on the account.",
    "asaasPixOnly": "Asaas currently supports only PIX. The selection is fixed to keep the flow safe.",
    "efiCredentials": "EFI Bank credentials",
    "efiEnvironment": "Environment",
    "efiEnvironmentProduction": "Production",
    "efiEnvironmentSandbox": "Sandbox",
    "efiEnvironmentHelp": "Use Sandbox for tests (pix-h.api.efipay.com.br). Production requires a production certificate.",
    "efiClientIdPlaceholder": "PIX application Client_Id from Efí account",
    "efiClientIdStoredHint": "Client_Id already saved. Fill in only to replace it.",
    "efiClientSecretPlaceholder": "Application Client_Secret",
    "efiClientSecretEditPlaceholder": "leave blank to keep current secret",
    "efiCertificateP12": "Certificate .p12 / .pfx",
    "efiCertificateSelected": "Selected file: {name}",
    "efiCertificateStoredHint": "Certificate already saved. Upload a new file only if you want to replace it.",
    "efiCertificateHelp": "Upload the PFX (.p12) certificate downloaded from Efí → API → My Certificates. The API requires mTLS on every request (OAuth + Pix).",
    "efiCertificatePassphrase": "Certificate password",
    "efiCertificatePassphrasePlaceholder": "leave empty if the .p12 has no password",
    "efiCertificatePassphraseHelp": "Some Efí certificates are password-protected. If yours has no password, leave this blank.",
    "efiCertificateInvalidExtension": "Please select a valid .p12 or .pfx file.",
    "efiCertificateReadError": "Could not read the certificate file.",
    "efiPixKeyHelp": "Random PIX key (EVP) registered in Efí — used to create charges.",
    "efiWebhookDescription": "This URL (?ignorar=) is registered automatically at Efí when saving. Authentication is mTLS on the web server, not a token.",
    "efiWebhookRequiredHint": "Configure mTLS on your server with Efí's public certificate. Production: certificados.efipay.com.br/webhooks/certificate-chain-prod.crt — Sandbox: certificate-chain-homolog.crt. Source IP: 34.193.116.226.",
    "efiWebhookMtlsHelp": "Efí validates mTLS on the URL before registering the webhook. Without mTLS on your domain, registration fails with \"mutual TLS not configured\".",
    "efiPixOnly": "EFI Bank only supports PIX at the moment.",
    "webhookUrl": "Webhook URL (Global)",
    "webhookDescription": "Configure this URL in Mercado Pago → Developers → Webhooks to receive payment notifications",
    "webhookCopied": "Webhook URL copied successfully",
    "accountSalesTitle": "Account Sales",
    "accountSalesDesc": "Sell SSH/V2Ray automatically",
    "resellerSalesTitle": "Reseller Sales",
    "resellerSalesDesc": "Sell reseller plans",
    "publicSalesUrl": "Public Sales URL",
    "publicResellerUrl": "Public Reseller URL",
    "totalSales": "Total sales:",
    "totalRevenue": "Total revenue:",
    "activeResellers": "Active resellers:",
    "categoryNotDefined": "Not defined",
    "goToAccountPlansTitle": "Go to Account Plans?",
    "goToResellerPlansTitle": "Go to Reseller Plans?",
    "goToServersTitle": "Go to Servers?",
    "activeServersInCategory": "{count} active server(s) in this category",
    "noActiveServersInCategory": "No active servers in this category — required for SSH/Combo plans",
    "featureEnabledWithUrl": "Enabled! URL: {url}",
    "featureDisabled": "Disabled",
    "publicTestsTitle": "Free Public Trials",
    "publicTestsDesc": "Let customers generate trials from the web",
    "publicTestsGloballyDisabled": "Globally disabled by the administrator",
    "publicTestsCategoryLabel": "Public trial category",
    "publicTestUrl": "Public Trial URL",
    "publicTestsInfo": "Duration: {duration}h • Global cooldown: {cooldown}h per email"
  },
  "resellers": {
    "title": "Resellers",
    "subtitle": "Manage all resellers",
    "addReseller": "New Reseller",
    "editReseller": "Edit Reseller",
    "username": "Username",
    "email": "Email",
    "category": "Category",
    "credit": "Credit",
    "status": "Status",
    "actions": {
      "addCredits": "Add Credits",
      "renewSubscription": "Renew Subscription",
      "viewAsReseller": "View as this reseller",
      "activate": "Activate",
      "deactivate": "Deactivate"
    },
    "noResellers": "No resellers found",
    "addCredit": "Add Credit",
    "removeCredit": "Remove Credit",
    "search": "Search",
    "totalResellers": "Total Resellers",
    "activeResellers": "Active Resellers",
    "distributedCredits": "Distributed Credits",
    "createdLogins": "Created Logins",
    "creditsLimit": "Credits/Limit",
    "type": "Type",
    "typeCredit": "Credit",
    "typeSubscription": "Subscription",
    "selectCategory": "Select a category",
    "initialCredits": "Initial Credits",
    "noResellersFound": "No resellers found",
    "clickToCreate": "Click \"New Reseller\" to create the first one",
    "planType": "Plan Type",
    "planActive": "Active plan",
    "filters": {
      "search": "Search",
      "searchPlaceholder": "Name, username or email...",
      "category": "Category",
      "allCategories": "All categories",
      "planType": "Plan type",
      "allTypes": "All types",
      "status": "Status",
      "allStatus": "All statuses",
      "creatorType": "Creator type",
      "allCreatorTypes": "All types",
      "admins": "Admins",
      "resellersOnly": "Resellers",
      "creator": "Creator",
      "allCreators": "All creators",
      "searchCreator": "Search creator...",
      "noCreatorsFound": "No creators found"
    },
    "resellers_count": "resellers",
    "stats": {
      "total": "Total resellers",
      "active": "Active resellers",
      "creditsDistributed": "Credits distributed",
      "slotsDistributed": "Distributed slots",
      "distributedResources": "Distributed resources",
      "loginsCreated": "Logins created"
    },
    "table": {
      "username": "Username",
      "category": "Category",
      "creditsLimit": "Credits/Limit",
      "logins": "Logins",
      "status": "Status",
      "actions": "Actions",
      "type": "Type",
      "available": "available",
      "total": "total",
      "reseller": "Reseller",
      "active": "active"
    },
    "creditsModal": {
      "addCreditsTitle": "Add Credits",
      "adjustSubscriptionTitle": "Renew/Adjust Subscription",
      "currentBalance": "Current Balance",
      "credits": "credits",
      "amount": "Amount",
      "amountPlaceholder": "Ex: 100",
      "negativeHelp": "Use negative value to remove credits",
      "observation": "Observation",
      "observationPlaceholder": "Reason for change...",
      "currentStatus": "Current Status",
      "limitHelp": "0 = keep current ({current}). In use: {used} slots"
    },
    "createModal": {
      "manual": "Manual Creation",
      "byPlan": "By Plan",
      "selectPlan": "Select a Plan",
      "choosePlan": "Choose a plan...",
      "planDetails": "Plan Details",
      "planType": "Type",
      "price": "Price",
      "usernameLabel": "Username",
      "usernamePlaceholder": "reseller_username",
      "emailLabel": "Email",
      "emailPlaceholder": "reseller{'@'}example.com",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Access password",
      "autoCredentialsInfo": "Enter the reseller username, email and access password",
      "selectPlanError": "Select a plan and a category",
      "categoryRequired": "Category is required",
      "successCreated": "Reseller created successfully!",
      "successUpdated": "Reseller updated successfully!",
      "errorSaving": "Error saving reseller"
    },
    "categoryInherited": "Category automatically inherited from your reseller account",
    "newReseller": "New Reseller",
    "newResellerShort": "New",
    "deleteSelectedShort": "Delete",
    "selectAll": "Select All",
    "deleteSelected": "Delete Selected",
    "passwordRequired": "Password",
    "newPasswordHelp": "New Password (leave blank to keep current)",
    "creditsPlaceholder": "Ex: 100",
    "durationPlaceholder": "Ex: 30",
    "minDurationDaysHelp": "Minimum: {min} days",
    "loginLimitPlaceholder": "Ex: 50",
    "days": "days",
    "logins": "logins",
    "credits": "credits",
    "planTypeLabel": "Reseller Type",
    "creditTypeDesc": "Credit amount",
    "subscriptionTypeDesc": "Duration + Login limit",
    "creditResellerRestriction": "CREDIT type reseller can only create CREDIT sub-resellers and plans",
    "blockedParentCredit": "🔒 Blocked (parent is Credit)",
    "blockedParentSubscribe": "🔒 Blocked (parent is Subscription)",
    "durationDaysLabel": "Duration (days)",
    "loginLimitLabel": "Login Limit",
    "expiresIn": "Expires in:",
    "expiresAt": "Expiration date",
    "editExpiresAtHelp": "Manually set the subscription expiration date and time.",
    "editExpiresAtRequired": "Enter the subscription expiration date.",
    "editLimitRequired": "Enter the login limit (minimum 1).",
    "editLimitBelowUsage": "The limit cannot be lower than logins in use ({used}).",
    "addDaysLabel": "Add Days",
    "newLimitLabel": "New Limit",
    "observationLabel": "Observation",
    "observationPlaceholder": "Reason for change...",
    "deleteModal": {
      "title": "Confirm Deletion",
      "question": "Are you sure you want to delete reseller",
      "cannotUndo": "This action cannot be undone!",
      "creditsReturnTitle": "Credits Will Be Returned",
      "creditsReturnBody": "{count} credit(s) will be returned to reseller:",
      "activeLoginsWarning": "This reseller has {count} active login(s)!",
      "deleting": "Deleting..."
    },
    "renewSubscription": {
      "title": "Renew Subscription",
      "subtitle": "Choose a plan to renew your reseller subscription.",
      "currentSubscription": "Your Current Subscription",
      "slots": "Slots",
      "status": "Status",
      "expiresAt": "Expires on",
      "loadingPlans": "Loading plans...",
      "noPlans": "No renewal plans available.",
      "contactAdmin": "Contact your administrator.",
      "slotsLabel": "slots",
      "confirmTitle": "Confirm Renewal",
      "plan": "Plan",
      "duration": "Duration",
      "total": "Total",
      "paymentMethod": "Payment Method",
      "processing": "Processing...",
      "payAmount": "Pay R$ {amount}",
      "openPayment": "Open Payment",
      "loadError": "Error loading data. Try again.",
      "noGateway": "No payment gateway configured.",
      "paymentCreateError": "Error creating payment",
      "paymentProcessError": "Error processing payment"
    },
    "buyCredits": {
      "title": "Buy Credits",
      "subtitle": "Purchase credits to create and manage your clients' accounts.",
      "currentBalance": "Current Balance",
      "creditHint": "1 credit = 1 account created for 30 days",
      "loadingPlans": "Loading plans...",
      "noPlans": "No credit packages available.",
      "contactAdmin": "Contact your administrator.",
      "perCredit": "credit",
      "confirmTitle": "Confirm Purchase",
      "package": "Package",
      "creditsLabel": "Credits",
      "balanceAfter": "Balance after purchase",
      "total": "Total",
      "paymentMethod": "Payment Method",
      "processing": "Processing...",
      "payAmount": "Pay R$ {amount}",
      "openPayment": "Open Payment",
      "loadError": "Error loading data. Try again.",
      "noGateway": "No payment gateway configured.",
      "paymentCreateError": "Error creating payment",
      "paymentProcessError": "Error processing payment"
    },
    "bulkDeleteConfirm": {
      "title": "Delete {count} reseller(s)?",
      "warning": "WARNING! This action is IRREVERSIBLE!",
      "question": "Do you really want to DELETE {count} reseller(s)?",
      "moreCount": " and {count} more",
      "bulletDb": "They will be removed from the database",
      "bulletAccountsKept": "All accounts created by them will be removed from servers and the database",
      "bulletSalesKept": "Sales will be kept for history",
      "finalWarning": "This action CANNOT be undone!"
    },
    "bulkDeleteModal": {
      "title": "Delete {count} reseller(s)?",
      "keepOpenHint": "Deletion continues in the background. Please wait until it finishes."
    },
    "resultModal": {
      "title": "Reseller created successfully",
      "categoryLabel": "Category",
      "planLabel": "Plan",
      "expiresAtLabel": "Valid until",
      "accessTitle": "Access details",
      "createdModePlan": "By plan",
      "createdModeManual": "Manual",
      "copyHint": "Copy the details below or send a ready-made message via WhatsApp/Telegram."
    },
    "messages": {
      "impersonateSuccess": "Viewing as: {username}",
      "impersonateError": "Error entering reseller account",
      "impersonateMissingUser": "Reseller has no linked user"
    }
  },
  "languageSelector": {
    "changed": "Language changed to {language}!"
  },
  "modals": {
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "edit": "Edit",
    "delete": "Delete",
    "confirm": "Confirm",
    "close": "Close",
    "loading": "Loading...",
    "saving": "Saving...",
    "deleting": "Deleting...",
    "success": "Success!",
    "error": "Error",
    "confirmDelete": "Are you sure you want to delete?",
    "required": "Required field",
    "creating": "Creating...",
    "add": "Add"
  },
  "deletionJobs": {
    "started": "Deletion started in the background…",
    "startedBulk": "Deleting {count} account(s)…",
    "startedBulkResellers": "Deleting {count} reseller(s)…",
    "running": "Removing from servers…",
    "serversSync": "Removing from servers…",
    "databaseSync": "Removing from database…",
    "progress": "{processed} of {total} processed",
    "progressSteps": "Step {step} of {serverSteps} — servers",
    "progressServer": "Server {step} of {serverSteps}: {name}",
    "progressPercent": "{percent}% complete",
    "progressReseller": "Reseller {step} of {total}",
    "uncertain": "Deletion may still be running. The list will refresh — check again shortly.",
    "completed": "Deletion completed",
    "failed": "Deletion failed",
    "syncWarningsTitle": "Server sync warnings:",
    "syncWarningsMore": "… and {count} more server(s) with warnings.",
    "syncUnknownError": "Sync failed"
  },
  "common": {
    "yes": "Yes",
    "no": "No",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "saveNow": "Save Now",
    "discard": "Discard",
    "delete": "Delete",
    "remove": "Remove",
    "edit": "Edit",
    "add": "Add",
    "create": "Create",
    "update": "Update",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "import": "Import",
    "refresh": "Refresh",
    "loading": "Loading...",
    "noData": "No data available",
    "actions": "Actions",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "prevPage": "Previous",
    "nextPage": "Next",
    "paginationSummary": "Page {page} of {totalPages} · {total} records",
    "confirmClearNotifications": "Clear notifications?",
    "confirmClearNotificationsDesc": "Do you really want to clear all notifications? This action cannot be undone.",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Information",
    "close": "Close",
    "copy": "Copy",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "finish": "Finish",
    "total": "Total",
    "from": "From",
    "to": "To",
    "date": "Date",
    "time": "Time",
    "name": "Name",
    "description": "Description",
    "details": "Details",
    "settings": "Settings",
    "profile": "Profile",
    "logout": "Logout",
    "toggleTheme": "Toggle theme",
    "login": "Login",
    "register": "Register",
    "username": "Username",
    "password": "Password",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "required": "Required",
    "optional": "Optional",
    "select": "Select",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "perPage": "Per page",
    "showing": "Showing",
    "of": "of",
    "results": "results",
    "ok": "OK",
    "selectPlaceholder": "Select...",
    "copied": "Copied!",
    "copyError": "Failed to copy",
    "copiedWithLabel": "{label} copied!",
    "copyManual": "Failed to copy. Copy manually (Ctrl+C)",
    "noItems": "No items found",
    "noItemsDescription": "No data to display",
    "itemsSelected": "{count} item(s) selected",
    "itemsPerPage": "Items per page:",
    "pageOf": "{current} of {total}",
    "firstPage": "First page",
    "prevPageTitle": "Previous page",
    "nextPageTitle": "Next page",
    "lastPage": "Last page",
    "user": "User",
    "expand": "Expand menu",
    "collapse": "Collapse menu",
    "menu": "Menu",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "open": "Open",
    "uuid": "UUID",
    "panelLink": "Panel link",
    "notAvailable": "N/A",
    "day": "day",
    "days": "days",
    "unknownError": "Unknown error",
    "roles": {
      "super_admin": "Super Administrator",
      "admin": "Administrator",
      "reseller": "Reseller",
      "sub_reseller": "Sub-reseller",
      "user": "User"
    },
    "closeModal": "Close modal",
    "closeNotification": "Close notification",
    "closeTab": "Close tab {label}",
    "closeError": "Close error",
    "saving": "Saving..."
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome back, {name}",
    "goodMorning": "Good morning! Here's your panel summary.",
    "goodAfternoon": "Good afternoon! Everything is running smoothly.",
    "goodEvening": "Good evening! Your panel is operational.",
    "refresh": "Refresh",
    "createTest": "Create Test",
    "overview": "Overview",
    "statistics": "Statistics",
    "totalAccounts": "Total Accounts",
    "todayCount": "+{count} today",
    "activeCount": "✓ {count} active",
    "expiredCount": "✗ {count} expired",
    "servers": "Servers",
    "serversOnline": "{count} online",
    "onlinePercentage": "{percent}% online",
    "activeConnections": "Active Connections",
    "onlines": "Online",
    "onlinesDesc": "Your accounts connected now",
    "onlinesTotal": "Total online",
    "onlinesTotalDesc": "All panel accounts connected",
    "onlinesAdmin": "Admin online",
    "onlinesAdminDesc": "Admin-created accounts connected",
    "rightNow": "Right now",
    "realtimeMonitoring": "Real-time monitoring",
    "expiringSoon": "Expiring Soon",
    "next7Days": "Next 7 days",
    "viewAccounts": "View accounts",
    "disabled": "Disabled",
    "accountsPaused": "Paused accounts",
    "expired": "Expired",
    "awaitingRenewal": "Awaiting renewal",
    "thisWeek": "This Week",
    "last7Days": "Last 7 days",
    "thisMonth": "This Month",
    "credits": "Credits",
    "creditsRemaining": "Credits remaining",
    "buyCreditsHint": "Click to buy more",
    "slots": "Slots",
    "slotsRemaining": "Slots remaining",
    "slotsInUse": "{used} of {total} in use",
    "renewSlotsHint": "Click to upgrade your subscription",
    "subscription": {
      "expiredBanner": "Your subscription has expired! Your features are blocked.",
      "expiringBanner": "Your subscription expires in {days} day(s). Renew to keep operating.",
      "renewNow": "Renew Now",
      "expiresTooltip": "Expires: {date}",
      "expired": "Expired",
      "oneDay": "1 day",
      "daysShort": "{days}d",
      "daysCount": "{days} days",
      "daysRemaining": "Days remaining",
      "accessExpiresAt": "Access valid until {date}",
      "managementPanel": "Management Panel"
    },
    "topResellers": "Top Resellers",
    "topResellersDesc": "Resellers with most accounts created",
    "position": "Position",
    "reseller": "Reseller",
    "activeAccounts": "Active",
    "activationRate": "Activation Rate",
    "totalAccountsDesc": "Total in system",
    "totalAdmin": "Admin Accounts",
    "totalAdminDesc": "Created by admin",
    "expiredAdmin": "Admin Expired",
    "expiredAdminDesc": "Expired by admin",
    "salesToday": "Today's Sales",
    "salesMonth": "Monthly Sales",
    "salesTotal": "Total Revenue",
    "salesCount": "{count} sale(s)",
    "salesTrend": "Sales Trend",
    "accountGrowth": "Account Growth",
    "totalUsers": "Total Users",
    "activeUsers": "Active Users",
    "totalServers": "Total Servers",
    "activeServers": "Active Servers",
    "totalSSH": "SSH Accounts",
    "totalV2Ray": "V2Ray Accounts",
    "onlineUsers": "Online Users",
    "offlineUsers": "Offline Users",
    "revenue": "Revenue",
    "lastMonth": "Last Month",
    "growth": "Growth",
    "recentUsers": "Recent Users",
    "recentActivities": "Recent Activities",
    "systemHealth": "System Health",
    "cpuUsage": "CPU Usage",
    "memoryUsage": "Memory Usage",
    "diskUsage": "Disk Usage",
    "networkTraffic": "Network Traffic"
  },
  "users": {
    "title": "Manage Users",
    "createUser": "Create User",
    "editUser": "Edit User",
    "deleteUser": "Delete User",
    "username": "Username",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "email": "Email",
    "phone": "Phone",
    "expirationDate": "Expiration Date",
    "connectionLimit": "Connection Limit",
    "deviceLimit": "Device Limit",
    "server": "Server",
    "category": "Category",
    "notes": "Notes",
    "totalUsers": "Total Users",
    "activeUsers": "Active Users",
    "expiredUsers": "Expired Users",
    "suspendedUsers": "Suspended Users",
    "userCreated": "User created successfully!",
    "userUpdated": "User updated successfully!",
    "userDeleted": "User deleted successfully!",
    "confirmDelete": "Are you sure you want to delete this user?",
    "suspendUser": "Suspend User",
    "activateUser": "Activate User",
    "renewUser": "Renew User"
  },
  "payment": {
    "title": "Payments",
    "config": "Payment Configuration",
    "create": "Create Payment",
    "history": "Payment History",
    "paymentLink": "Payment Link",
    "qrCode": "QR Code",
    "amount": "Amount",
    "discount": "Discount",
    "total": "Total",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "cancelled": "Cancelled",
    "paymentCreated": "Payment created successfully!",
    "copyLink": "Copy Link",
    "shareWhatsApp": "Share on WhatsApp",
    "sendEmail": "Send by Email",
    "print": "Print",
    "expiresAt": "Expires at",
    "clientName": "Client Name",
    "clientEmail": "Client Email",
    "clientPhone": "Client Phone",
    "selectGateway": "Select Payment Gateway",
    "configurethreshold": "Configure Payment Gateway",
    "gatewayNotConfigured": "Payment gateway not configured"
  },
  "coupons": {
    "title": "Discount Coupons",
    "subtitle": "Create and manage discount coupons for your customers",
    "newCoupon": "New Coupon",
    "newCouponShort": "New",
    "createCoupon": "Create Coupon",
    "editCoupon": "Edit Coupon",
    "deleteCoupon": "Delete Coupon",
    "code": "Code",
    "discountType": "Discount Type",
    "percentage": "Percentage",
    "fixedValue": "Fixed Value",
    "discountAmount": "Discount Amount",
    "percentLabel": "Percentage (%)",
    "fixedLabel": "Amount (R$)",
    "maxUses": "Maximum Uses",
    "validUntil": "Valid Until",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "active": "Active",
    "inactive": "Inactive",
    "total": "Total",
    "activeCount": "Active",
    "uses": "Uses",
    "emptyTitle": "No coupons",
    "emptyHint": "Create your first discount coupon",
    "discountLabel": "Discount:",
    "usesLabel": "Uses:",
    "validUntilLabel": "Valid until:",
    "codePlaceholder": "SAVE10",
    "percentPlaceholder": "10.00",
    "fixedPlaceholder": "5.00",
    "percentageExample": "E.g.: 10%",
    "fixedExample": "E.g.: $5",
    "unlimitedPlaceholder": "Unlimited",
    "deleteConfirm": "Are you sure you want to delete coupon \"{code}\"?",
    "couponApplied": "Coupon applied!",
    "couponInvalid": "Invalid or expired coupon",
    "couponCreated": "Coupon created successfully!",
    "couponUpdated": "Coupon updated successfully!",
    "couponDeleted": "Coupon deleted successfully!"
  },
  "announcements": {
    "inboxTitle": "Announcements",
    "inboxSubtitle": "Notices and updates published by the administration",
    "manageTitle": "Manage Announcements",
    "manageSubtitle": "Publish notices for resellers and sub-resellers",
    "new": "New Announcement",
    "createTitle": "Create Announcement",
    "editTitle": "Edit Announcement",
    "pinned": "Pinned",
    "draft": "Draft",
    "inactive": "Inactive",
    "notPublished": "Not published",
    "markAllRead": "Mark all as read",
    "markAllSuccess": "All announcements marked as read",
    "unreadBanner": "You have {count} unread announcement(s)",
    "readCount": "{count} read(s)",
    "publishedAt": "Published on {date}",
    "emptyTitle": "No announcements",
    "emptyInboxHint": "When there are announcements, they will appear here",
    "emptyManageHint": "Create the first announcement for your resellers",
    "deleteTitle": "Delete announcement",
    "deleteMessage": "Do you want to delete the announcement \"{title}\"?",
    "deleteSuccess": "Announcement removed successfully",
    "saveSuccess": "Announcement saved successfully",
    "form": {
      "title": "Title",
      "body": "Content",
      "audience": "Target audience",
      "priority": "Priority",
      "expiresAt": "Expires at",
      "expiresAtHint": "Optional. Leave blank for no expiration.",
      "pinned": "Pin to top",
      "active": "Active",
      "publishNow": "Publish now",
      "unpublish": "Unpublish (back to draft)"
    },
    "audience": {
      "all_resellers": "All resellers",
      "resellers": "Resellers only",
      "sub_resellers": "Sub-resellers only"
    },
    "priority": {
      "normal": "Normal",
      "important": "Important",
      "urgent": "Urgent"
    },
    "editor": {
      "placeholder": "Type the announcement content...",
      "toolbarLabel": "Text formatting",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "bulletList": "Bullet list",
      "numberedList": "Numbered list",
      "heading": "Subtitle",
      "paragraph": "Normal paragraph",
      "link": "Insert link",
      "linkPrompt": "Link URL (https://...)",
      "linkTextPrompt": "Link text (display label)",
      "help": "Select text and use the buttons above. Enter creates a new paragraph; lists and links apply to the selected text."
    },
    "errors": {
      "load": "Failed to load announcements",
      "save": "Failed to save announcement",
      "delete": "Failed to delete announcement",
      "markRead": "Failed to mark announcements as read",
      "emptyBody": "Enter the announcement content before saving"
    }
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications",
    "unreadTitle": "{count} unread notification(s)",
    "markAllRead": "Mark as read",
    "clearAll": "Clear all",
    "remove": "Remove notification",
    "expiration": {
      "accountExpiringTitle": "Account expiring soon",
      "accountExpiringMessage": "Account {username} expires in {days} day(s) ({expiresAt}).",
      "accountExpiredTitle": "Account expired",
      "accountExpiredMessage": "Account {username} expired on {expiresAt} and was deactivated.",
      "resellerExpiringTitle": "Subscription expiring soon",
      "resellerExpiringMessage": "Reseller {username} expires in {days} day(s) ({expiresAt}).",
      "resellerExpiredTitle": "Subscription expired",
      "resellerExpiredMessage": "Reseller {username} expired on {expiresAt} and was deactivated."
    },
    "announcement": {
      "newTitle": "New announcement: {title}",
      "newMessage": "Tap to read the full notice."
    }
  },
  "backupJobProgress": {
    "processing": "Processing...",
    "doNotClose": "This may take a few minutes. Do not close this window.",
    "completed": "Completed successfully!",
    "fileInfo": "File: {filename} ({size} MB)",
    "errorPrefix": "Error:",
    "failed": "Processing failed",
    "pending": "Waiting for processing..."
  },
  "install": {
    "subtitle": "Installation Wizard",
    "toggle_theme": "Toggle light/dark theme",
    "lang_change_later": "You can change the language later in settings",
    "step_language": "Language",
    "step_language_desc": "Select the panel language",
    "step_requirements": "Requirements",
    "step_requirements_desc": "System requirements verification",
    "step_database": "Database",
    "step_database_desc": "Configure the MySQL connection",
    "step_admin": "Administrator",
    "step_admin_desc": "Create the admin account",
    "step_install": "Installation",
    "step_install_desc": "System installation execution",
    "step_of": "Step {current} of {total}",
    "req_api": "Backend API Accessible",
    "db_host": "Database Host",
    "db_user": "Database User",
    "db_password": "Database Password",
    "db_name": "Database Name",
    "test_connection": "Test Connection",
    "testing": "Testing...",
    "connection_error": "Failed to connect to the database",
    "admin_user": "Admin Username",
    "admin_email": "Admin Email",
    "admin_password": "Admin Password",
    "admin_confirm": "Confirm Password",
    "passwords_mismatch": "Passwords do not match",
    "back": "Back",
    "next": "Next",
    "install_now": "Install Now",
    "processing": "Processing...",
    "progress": "Progress",
    "log_starting": "Starting installation...",
    "log_connecting": "Connecting to the database...",
    "log_schemas": "Executing database schemas...",
    "log_done": "Installation completed successfully!",
    "log_error": "Error during installation",
    "success_title": "Installation Complete!",
    "success_message": "The system has been installed successfully. You can now log in.",
    "go_to_login": "Go to Login",
    "retry": "Try Again"
  },
  "validation": {
    "required": "This field is required",
    "email": "Enter a valid email",
    "minLength": "Must be at least {min} characters",
    "maxLength": "Must be at most {max} characters",
    "min": "Must be greater than or equal to {min}",
    "max": "Must be less than or equal to {max}",
    "alphanumeric": "Must contain only letters and numbers",
    "numeric": "Must contain only numbers",
    "url": "Enter a valid URL",
    "ip": "Enter a valid IP",
    "port": "Enter a valid port (1-65535)",
    "passwordStrength": "Password must contain uppercase, lowercase, numbers and special characters",
    "passwordMatch": "Passwords do not match",
    "unique": "This value is already in use",
    "dateFormat": "Invalid date format",
    "futureDate": "Date must be in the future",
    "pastDate": "Date must be in the past"
  },
  "salesMetrics": {
    "title": "Sales Metrics",
    "subtitle": "Track financial performance and payment history",
    "totalRevenue": "Total Revenue",
    "monthRevenue": "Monthly Revenue",
    "todayRevenue": "Today's Revenue",
    "pendingPayments": "Pending Payments",
    "awaitingConfirmation": "Awaiting confirmation",
    "sales": "sale(s)",
    "revenue": "Revenue",
    "revenueLast30Days": "Revenue — Last 30 Days",
    "revenueByMonth": "Revenue by Month",
    "byProductType": "By Product Type",
    "byGateway": "By Gateway",
    "paymentsHistory": "Payment History",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "statusApproved": "Approved",
    "statusPending": "Pending",
    "statusCancelled": "Cancelled",
    "statusExpired": "Expired",
    "typeAccount": "VPN Account",
    "typeReseller": "Reseller",
    "typeResellerRenewal": "Reseller renewal",
    "typeResellerCredits": "Credits purchase",
    "typeOther": "Other",
    "emptyValue": "—",
    "monthYearLabel": "{month}/{year}",
    "monthsShort": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "gateways": {
      "mercadopago": "Mercado Pago",
      "asaas": "Asaas",
      "paypal": "PayPal",
      "manual": "Manual",
      "pagseguro": "PagSeguro"
    },
    "dateFrom": "Start date",
    "dateTo": "End date",
    "colDate": "Date",
    "colDescription": "Description",
    "colCustomer": "Customer",
    "colType": "Type",
    "colGateway": "Gateway",
    "colStatus": "Status",
    "colValue": "Value",
    "noData": "No data for this period",
    "noPayments": "No payments found",
    "page": "Page",
    "records": "record(s)",
    "prev": "Previous",
    "next": "Next"
  },
  "notFound": {
    "documentTitle": "404 — {panel}",
    "page_title": "Page not found",
    "subtitle": "The address may be wrong or the page was removed",
    "title": "We couldn't find this route",
    "message": "Check the link or use the shortcuts below to return to the panel.",
    "attempted_path": "Requested path",
    "suggestions": "Useful shortcuts",
    "goBack": "Go back",
    "goHome": "Go to dashboard",
    "help_hint": "If the issue persists, contact your panel administrator",
    "needHelp": "Need help?",
    "contactSupport": "Contact us",
    "dashboardDesc": "System overview",
    "accountsDesc": "Manage accounts",
    "serversDesc": "Manage servers",
    "settingsDesc": "Panel settings"
  },
  "publicStoreAlerts": {
    "ok": "OK",
    "notice": "Notice",
    "warning": "Warning",
    "info": "Information"
  },
  "publicStore": {
    "types": {
      "ssh": "SSH",
      "v2ray": "V2Ray",
      "combo": "SSH + V2Ray"
    },
    "account": {
      "subtitle": "Choose your SSH/V2Ray access plan",
      "loadingPlans": "Loading plans...",
      "validityDays": "{days} days validity",
      "unlimitedConnections": "Unlimited connections",
      "connectionsCount": "{count} connections",
      "instantActivation": "Instant activation",
      "support247": "24/7 support",
      "buyNow": "Buy Now",
      "noPlans": "No plans available at the moment.",
      "noServersInCategoryTitle": "Store temporarily unavailable",
      "noServersInCategory": "There are no active servers in the sales category. Please contact the seller.",
      "filterPlans": "Filter plans by type"
    },
    "reseller": {
      "subtitle": "Become a reseller — choose your plan",
      "loadingPlans": "Loading plans...",
      "typeCredit": "Credit",
      "typeSubscribe": "Subscription",
      "filterPlans": "Filter plans by type",
      "creditsAmount": "{count} credits",
      "durationDays": "{days} days",
      "simultaneousLogins": "{count} simultaneous logins",
      "managementPanel": "Management panel",
      "instantActivation": "Instant activation",
      "fullSupport": "Full support",
      "commonBenefits": "Management panel • Instant activation • Full support",
      "becomeReseller": "Become a Reseller",
      "noPlans": "No reseller plans available at the moment."
    }
  },
  "publicPayment": {
    "checkout": "Checkout",
    "selectedPlan": "Selected plan",
    "planSummary": "{days} days • {connections} connections",
    "fullName": "Full Name",
    "email": "Email",
    "cpf": "CPF",
    "dni": "DNI",
    "curp": "CURP",
    "rut": "RUT",
    "cc": "ID card",
    "ci": "CI",
    "documentLabel": "{doc}",
    "whatsappOptional": "WhatsApp (optional)",
    "telegramOptional": "Telegram (optional)",
    "placeholderName": "Your name",
    "payerNameHint": "Full name of the document holder (required for Mercado Pago)",
    "placeholderEmail": "you{'@'}email.com",
    "placeholderCpf": "000.000.000-00",
    "placeholderDocument": "Payer document",
    "placeholderWhatsapp": "(11) 99999-9999",
    "placeholderTelegram": "{'@'}username or ID",
    "cancel": "Cancel",
    "continue": "Continue",
    "back": "Back",
    "paymentMethodTitle": "Payment Method",
    "processing": "Processing...",
    "payNow": "Pay Now",
    "noPaymentMethods": "No payment methods available",
    "paymentCreateError": "Error creating payment. Please try again.",
    "cpfInvalid": "Enter a valid CPF (11 digits with correct check digits).",
    "cpfAutoFillHint": "CPF is generated automatically to speed up checkout. You can edit it or generate another.",
    "regenerateCpf": "Generate another",
    "documentInvalid": "Enter a valid document ({doc}).",
    "dataAlreadyExists": "Data already exists",
    "resellerCredentialsTitle": "Panel Access Credentials",
    "resellerCredentialsHelp": "Choose your credentials to access the reseller panel",
    "username": "Username",
    "usernameTaken": "Username is already taken. Choose another one.",
    "usernameAvailable": "Username is available!",
    "usernameRequired": "Enter a username.",
    "checkingUsername": "Checking username...",
    "usernameCheckError": "Could not verify username. Please try again.",
    "emailTaken": "Email is already in use. Choose another one.",
    "emailAvailable": "Email is available!",
    "checkingEmail": "Checking email...",
    "emailCheckError": "Could not verify email. Please try again.",
    "checkingCredentials": "Checking details...",
    "payerNameRequired": "Enter the payer's full name.",
    "nameRequired": "Enter your full name.",
    "emailRequired": "Enter an email address.",
    "emailInvalid": "Enter a valid email address.",
    "cpfRequired": "Enter your CPF.",
    "documentRequired": "Enter your {doc}.",
    "payerDocumentSectionTitle": "Payer identification",
    "payerDocumentSectionHint": "Required for payment with {method}.",
    "payerDocumentSectionHintPayment": "Identification sent with the {method} payment request.",
    "payerDocumentSectionHintCustomer": "Tax ID used to register the customer with the gateway (reused for future charges). Required for {method}.",
    "passwordRequired": "Password must be at least 6 characters.",
    "usernamePlaceholder": "yourname123",
    "emailForLogin": "Email",
    "emailForLoginHint": "(for panel login)",
    "emailPlaceholder": "email{'@'}panel.com",
    "password": "Password",
    "passwordHint": "(minimum 6 characters)",
    "methodInstant": "Instant",
    "methodCash": "Cash",
    "methodCard": "Card",
    "methodBankTransfer": "Bank transfer",
    "methodWallet": "Wallet",
    "pixTitle": "PIX Payment",
    "cardMissingPublicKey": "Card unavailable: the seller must configure the Mercado Pago Public Key.",
    "cardInvalidPublicKey": "Invalid Public Key. Use the public key (TEST-... or APP_USR-...), not the Access Token.",
    "cardAccessTokenInsteadOfPublicKey": "It looks like the Access Token was entered as the Public Key. In MP panel: Credentials → copy the Public Key, not the Access Token.",
    "cardInvalidAmount": "Invalid plan amount for card payment.",
    "cardBrickGetPaymentMethodsFailed": "Mercado Pago rejected the Public Key (get_payment_methods_failed). Check Automations → Gateways: correct public key, active application, and same environment (test/production) as the Access Token.",
    "cardBrickProductionKeyOnLocalhost": "You are on localhost with a production key (APP_USR-). For local testing, use test credentials (TEST-) or deploy to HTTPS with a real domain.",
    "cardBrickSecureFieldsFailed": "Failed to load secure card fields. Check script/iframe blockers and reload the page.",
    "cardNumberLabel": "Card number",
    "cardNumberPlaceholder": "0000 0000 0000 0000",
    "cardNumberInvalid": "Invalid card number. Please check the digits entered.",
    "cardNumberIncomplete": "Enter the full card number.",
    "cardExpiryLabel": "Expiry",
    "cardExpiryMonthLabel": "Month",
    "cardExpiryYearLabel": "Year",
    "cardYearInvalid": "Enter a 4-digit year (e.g. 2030).",
    "cardTestOnProduction": "You are using a TEST card with a PRODUCTION key (APP_USR). Test cards only work with TEST- credentials. Use a real card or switch to sandbox.",
    "cardSandboxHint": "Sandbox: in Name use APRO (ok), OTHE (error), CONT (pending), CALL, FUND, SECU, EXPI, FORM, DUPL, LOCK… Test CPF: 12345678909.",
    "cardCvvLabel": "CVV",
    "cardHolderLabel": "Name on card",
    "cardHolderHint": "As printed on the card — used for payment. The buyer name from the previous step is only for account registration.",
    "cardHolderRequired": "Enter the name printed on the card.",
    "cardDeviceSessionMissing": "Could not read Mercado Pago antifraud session. Hard-reload with Ctrl+F5, wait 5 seconds on the card screen and try again.",
    "cardDeviceSessionPending": "Loading Mercado Pago antifraud session… wait a few seconds before paying.",
    "cardHolderPlaceholder": "As printed on card",
    "cardHolderPlaceholderSandbox": "APRO",
    "cardInstallmentsLabel": "Installments",
    "cardInstallmentsPlaceholder": "Enter card number first",
    "cardInstallmentsHint": "Installments are calculated by Mercado Pago after you enter the card number.",
    "cardInstallmentsLoading": "Calculating installments…",
    "cardInstallmentsLowAmount": "Low amount: usually cash only (1x). Try a plan above R$ 5 to see installments.",
    "cardBrickError": "Could not load the card form. Reload the page and try again.",
    "cardTokenError": "Could not tokenize the card. Check number, expiry, CVV and try again.",
    "cardProcessing": "Processing card payment",
    "cardPending": "Payment under review. Wait for confirmation or try again shortly.",
    "cardApprovedAwaitingDelivery": "Payment approved. Delivery is being processed — refresh in a few seconds if confirmation does not appear.",
    "pixStepScan": "Scan the QR",
    "pixStepPay": "Confirm in app",
    "pixStepWait": "Wait here",
    "pixExpiresIn": "Expires in ~{minutes} min",
    "pixExpired": "PIX expired",
    "pixScanHint": "Scan with your bank app",
    "pixCopyLabel": "Or copy the PIX key:",
    "copy": "Copy",
    "copied": "Copied!",
    "pixInstructions": "Open your bank app → PIX → Scan QR Code or Paste Key",
    "awaitingConfirmation": "Awaiting confirmation...",
    "cancelPayment": "Cancel Payment",
    "cancelling": "Cancelling...",
    "close": "Close",
    "pixExpiresHint": "PIX expires automatically if not paid",
    "paymentConfirmed": "Payment Confirmed!",
    "accountCreated": "Your account was created successfully",
    "accountRenewed": "Your account was renewed successfully",
    "resellerActivated": "Your reseller panel has been activated!",
    "creditsAddedSuccess": "Credits added successfully!",
    "creditsAddedLabel": "Credits added",
    "newCreditsBalance": "New balance",
    "creditsPurchaseToast": "+{added} credits added! Current balance: {balance}",
    "validUntil": "Valid until: {date}",
    "userLabel": "User",
    "passwordLabel": "Password",
    "uuidLabel": "UUID (V2Ray)",
    "copyAllCredentials": "Copy All Credentials",
    "copyResellerCredentials": "Copy Access Credentials",
    "typeLabel": "Type",
    "limitLabel": "Limit",
    "creditsLabel": "Credits",
    "resellerPanelCredentials": "Reseller Panel Credentials",
    "panelUrl": "Panel URL",
    "saveCredentialsWarning": "Keep this information in a safe place!",
    "cancelPaymentConfirm": "Are you sure you want to cancel this payment?\n\nPIX will no longer be payable after cancellation.",
    "cancelPaymentError": "Error cancelling payment. Please try again.",
    "copyManualPrompt": "Click OK to view your credentials and copy manually:",
    "copyManualTitle": "Copy these credentials (Ctrl+C):",
    "successTitle": "Payment Approved!",
    "successSubtitle": "Your credentials are ready",
    "credentialsSentEmail": "Credentials were also sent to your email.",
    "resellerWelcome": "Welcome!",
    "resellerSuccessSubtitle": "Your reseller account was activated successfully",
    "resellerLoginHint": "Log in to the panel to get started!",
    "resellerEmailSent": "Access details were sent to your email.",
    "successModal": {
      "expiresAtLabel": "Valid until",
      "connectionLimitLabel": "Connection limit",
      "loginLimitValue": "{limit} logins"
    }
  },
  "renewal": {
    "title": "Renew Access",
    "subtitle": "Renew your SSH/V2Ray account quickly and securely",
    "step1Title": "Find your account",
    "usernameOrUuidLabel": "Username or V2Ray UUID",
    "usernameOrUuidPlaceholder": "Enter your username or UUID",
    "usernameOrUuidHelp": "Enter the SSH account username or V2Ray UUID",
    "searchButton": "Search Account",
    "searching": "Searching...",
    "accountNotFound": "Account not found",
    "searchError": "Error searching account. Try again.",
    "accountFound": "Account Found!",
    "accountFoundSubtitle": "Choose a plan to renew",
    "username": "Username",
    "type": "Type",
    "expiresAt": "Expires At",
    "status": "Status",
    "expired": "Expired",
    "active": "Active",
    "availablePlans": "Available Plans",
    "loadingPlans": "Loading plans...",
    "days": "days",
    "connections": "connections",
    "renewNow": "Renew Now",
    "renewPlanSummary": "+{days} days • account {username}",
    "noPlansAvailable": "No plans available for renewal",
    "payment": "Payment",
    "changePlan": "Change plan",
    "selectedPlan": "Selected plan",
    "customerName": "Full Name",
    "optional": "optional",
    "paymentMethod": "Payment method",
    "noPaymentMethods": "No payment methods available.",
    "processing": "Processing...",
    "payNow": "Pay now",
    "paymentCreateError": "Error creating payment",
    "paymentProcessError": "Error processing payment",
    "successTitle": "Renewal completed!",
    "newExpiresAt": "New expiration: {date}",
    "typeSsh": "SSH",
    "typeV2ray": "V2Ray",
    "typeCombo": "SSH + V2Ray"
  },
  "nav": {
    "dashboard": "Dashboard",
    "accounts": "Accounts",
    "servers": "Servers",
    "categories": "Categories",
    "resellers": "Resellers",
    "payments": "Payments",
    "gateways": "Gateways",
    "coupons": "Coupons",
    "announcements": "Announcements",
    "salesMetrics": "Metrics",
    "settings": "Settings",
    "profile": "Profile",
    "logout": "Logout",
    "panel": "Panel",
    "manage": "Manage",
    "plans": "Plans",
    "system": "System",
    "administrators": "Administrators",
    "branding": "Branding",
    "checkuser": "CheckUser",
    "manageBackup": "Manage Backup",
    "systemLogs": "System Logs",
    "users": "Users",
    "automaticResale": "Automatic Resale",
    "portal": "Portal",
    "createLogin": "Create Login",
    "devices": "Devices",
    "paymentHistory": "Payment History",
    "configuration": "Configuration",
    "myUsers": "My Users",
    "documentation": "Documentation",
    "publicApiDocs": "Public APIs"
  },
  "errors": {
    "generic": "An unexpected error occurred",
    "networkError": "Connection error with the server",
    "serverError": "Internal server error",
    "notFound": "Resource not found",
    "unauthorized": "You do not have permission to access this resource",
    "forbidden": "Access denied",
    "badRequest": "Invalid request",
    "timeout": "Request took too long",
    "tooManyRequests": "Too many requests. Wait a moment.",
    "maintenance": "System under maintenance. Try again later.",
    "tryAgain": "Try again",
    "contactSupport": "If the problem persists, contact support"
  },
  "success": {
    "operationSuccess": "Operation completed successfully",
    "created": "Created successfully",
    "updated": "Updated successfully",
    "deleted": "Deleted successfully",
    "saved": "Saved successfully",
    "copied": "Copied to clipboard",
    "sent": "Sent successfully",
    "uploaded": "Upload completed successfully",
    "downloaded": "Download completed successfully",
    "imported": "Imported successfully",
    "exported": "Exported successfully"
  },
  "license": {
    "invalid": {
      "page_title": "License unavailable",
      "title": "Invalid or Expired License",
      "subtitle": "This panel requires a valid license to keep running",
      "error_occurred": "License Validation Error",
      "default_error_title": "Access denied",
      "default_error_message": "Your license is invalid, expired, or this domain is not authorized to use {panelName}.",
      "domain_info": "Domain information",
      "current_domain": "Current domain",
      "status": "License status",
      "status_invalid": "Invalid",
      "reason_code": "Reason code",
      "what_to_do": "What to do?",
      "step_1": "Contact your system provider or technical support",
      "step_2": "Share your current domain so the license can be activated or renewed",
      "step_3": "After the fix, click «Check license again» or reload the panel",
      "contact_support": "Contact support",
      "recheck": "Check license again",
      "checking": "Checking...",
      "recheck_success": "License validated! Redirecting to the panel...",
      "recheck_still_invalid": "The license is still invalid. Confirm with support and try again.",
      "recheck_failed": "Could not verify right now. Please try again shortly.",
      "managed_externally": "Licenses managed externally"
    },
    "status": {
      "expired": {
        "title": "License expired",
        "message": "This domain license has expired. Renew it to use {panelName} again.",
        "badge": "Expired",
        "hint": "Request renewal using the current domain."
      },
      "suspended": {
        "title": "License suspended",
        "message": "This license was suspended by the platform administrator.",
        "badge": "Suspended",
        "hint": "Contact support to restore access."
      },
      "draft": {
        "title": "License not activated",
        "message": "The license is still a draft and has not been released for use.",
        "badge": "Draft",
        "hint": "Wait for the license to be officially activated for this domain."
      },
      "not_found": {
        "title": "License not found",
        "message": "We could not find a valid license linked to this installation.",
        "badge": "Not found",
        "hint": "Confirm LICENSE_KEY is correct on the server."
      },
      "domain_mismatch": {
        "title": "Unauthorized domain",
        "message": "This license is bound to another domain and cannot be used here.",
        "badge": "Wrong domain",
        "hint": "Request a license migration to the current domain."
      },
      "missing_license_key": {
        "title": "Missing license key",
        "message": "The server has no LICENSE_KEY configured to validate the panel.",
        "badge": "No key",
        "hint": "Set LICENSE_KEY in the backend .env file."
      },
      "grace_period_expired": {
        "title": "Offline validation expired",
        "message": "The offline grace period ended. Reconnect the server to the internet to revalidate.",
        "badge": "Offline expired",
        "hint": "Check connectivity to the license server."
      },
      "connection_error": {
        "title": "Connection failed",
        "message": "Could not reach the license server at this time.",
        "badge": "No connection",
        "hint": "Check internet, firewall, and LICENSE_SERVER_URL."
      },
      "validation_failed": {
        "title": "Validation failed",
        "message": "License validation failed and the panel was blocked for safety.",
        "badge": "Validation failed",
        "hint": "Review LICENSE_KEY, domain, and server logs."
      },
      "critical_error": {
        "title": "Critical license error",
        "message": "An internal error occurred while validating the license.",
        "badge": "Critical error",
        "hint": "Check backend logs and contact support."
      },
      "unknown": {
        "title": "License not released",
        "message": "The license could not be confirmed for this domain.",
        "badge": "Unknown",
        "hint": "Share the reason code with support."
      },
      "invalid": {
        "title": "Invalid license",
        "message": "This domain license is not valid to use {panelName}.",
        "badge": "Invalid",
        "hint": "Request activation or renewal using the current domain."
      }
    }
  },
  "adminManagement": {
    "title": "Administrator Management",
    "subtitle": "Manage system administrators and moderators (Super Admin only)",
    "newAdmin": "New Administrator",
    "reload": "Reload",
    "saveChanges": "Save Changes",
    "filters": {
      "search": "Search",
      "searchPlaceholder": "ID, username, email, role, status, dates or permissions...",
      "role": "Role",
      "allRoles": "All",
      "status": "Status",
      "allStatus": "All"
    },
    "stats": {
      "total": "Total Admins",
      "active": "Active",
      "inactive": "Inactive"
    },
    "empty": {
      "title": "No administrators found",
      "description": "Click \"New Administrator\" to create the first one"
    },
    "table": {
      "administrator": "Administrator",
      "role": "Role",
      "status": "Status",
      "lastLogin": "Last Login",
      "createdAt": "Created at",
      "actions": "Actions",
      "never": "Never"
    },
    "roles": {
      "super_admin": "Super Admin",
      "admin": "Admin",
      "moderator": "Moderator"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "activate": "Activate",
      "deactivate": "Deactivate",
      "edit": "Edit",
      "delete": "Delete"
    },
    "modal": {
      "createTitle": "New Administrator",
      "editTitle": "Edit Administrator",
      "close": "Close",
      "cancel": "Cancel",
      "save": "Save Changes",
      "create": "Create Administrator",
      "saving": "Saving...",
      "deleting": "Deleting..."
    },
    "form": {
      "username": "Username",
      "usernamePlaceholder": "Ex: john_admin",
      "usernameHelp": "3-50 alphanumeric characters (cannot be changed later)",
      "email": "Email",
      "emailPlaceholder": "email{'@'}example.com",
      "role": "Role",
      "adminRole": "Admin - Full access",
      "moderatorRole": "Moderator - Limited access",
      "roleHelp": "Super Admin cannot be created via interface",
      "password": "Password",
      "newPassword": "New Password (optional)",
      "passwordPlaceholder": "Minimum 6 characters",
      "passwordHelp": "Leave blank to keep current password",
      "activeStatus": "Active Status",
      "activeStatusHelp": "Administrator can login"
    },
    "delete": {
      "title": "Confirm Deletion",
      "message": "Are you sure you want to delete the administrator",
      "warning": "This action cannot be undone.",
      "confirm": "Delete"
    },
    "messages": {
      "createSuccess": "Administrator created successfully!",
      "updateSuccess": "Administrator updated successfully!",
      "deleteSuccess": "Administrator deleted successfully!",
      "statusChanged": "Status changed successfully!",
      "createError": "Error creating administrator",
      "updateError": "Error updating administrator",
      "deleteError": "Error deleting administrator",
      "loadError": "Error loading administrators",
      "superAdminOnly": "Only Super Admin can access this area."
    },
    "viewOnly": "View only",
    "branding": {
      "title": "Branding & Customization",
      "description": "Manage logos, icons, favicon and visual appearance of the panel",
      "tabs": {
        "logos": "Logos",
        "icons": "Icons & Favicon",
        "pwa": "PWA & Social Media"
      },
      "upload": "Upload",
      "replace": "Replace",
      "remove": "Remove",
      "previewDefault": "Preview Default",
      "customBadge": "Custom",
      "defaultBadge": "Default",
      "uploading": "Uploading...",
      "formats": "Formats",
      "maxSize": "Max",
      "maxSourceSize": "Photo up to {max} MB (auto crop & compress)",
      "filePath": "File",
      "showDefault": "Show Default",
      "showCustom": "Show Custom",
      "fileTooLarge": "File too large!\n\nSize: {size} MB\nMaximum: {max} MB\n\nPlease compress the image before uploading.",
      "logosAndIconsDesc": "Customize your panel's visual identity",
      "recommendedSize": "Recommended size: 512x512px",
      "pwaSettings": "PWA Settings",
      "pwaName": "Full Application Name",
      "pwaShortName": "Short Name (max 12 chars)",
      "pwaDescription": "Application Description",
      "themeColor": "Theme Color",
      "dashboardLogo": "Dashboard Logo",
      "loginLogo": "Login Screen Logo",
      "panelLogo": "General Panel Logo",
      "faviconSvg": "Favicon SVG",
      "faviconPng": "Favicon PNG",
      "appleTouchIcon": "Apple Touch Icon",
      "appIcon192": "PWA Icon 192x192",
      "appIcon512": "PWA Icon 512x512",
      "ogImage": "Open Graph Image",
      "dashboardLogoDesc": "Displayed in sidebar and admin header",
      "loginLogoDesc": "Displayed on login screen",
      "panelLogoDesc": "Main logo used in emails, documents, etc",
      "faviconSvgDesc": "Browser tab icon - vector format (recommended)",
      "faviconPngDesc": "Fallback for browsers that do not support SVG",
      "appleTouchIconDesc": "Icon when adding to iOS home screen",
      "appIcon192Desc": "PWA app icon for Android/Chrome",
      "appIcon512Desc": "HD icon for splash screen and installation",
      "ogImageDesc": "Image for social sharing (Facebook, Twitter, WhatsApp)"
    },
    "settingsPage": {
      "title": "Panel Settings",
      "description": "Customize appearance, security and system behavior",
      "tabs": {
        "branding": "Branding",
        "security": "Security",
        "backup": "Backup",
        "cleanup": "Cleanup",
        "advanced": "Advanced",
        "templates": "Messages"
      },
      "branding": {
        "panelInfo": "Panel Information",
        "panelName": "Panel Name",
        "panelNamePlaceholder": "Ex: My Panel",
        "pwaShortName": "PWA Short Name",
        "pwaShortNamePlaceholder": "Ex: MyPanel",
        "max12chars": "Maximum 12 characters",
        "description": "Description",
        "descriptionPlaceholder": "Describe your panel...",
        "logosAndIcons": "Logos & Icons",
        "dashboardLogo": "Dashboard Logo",
        "dashboardLogoDesc": "Displayed in sidebar and header",
        "loginLogo": "Login Logo",
        "loginLogoDesc": "Displayed on login screen",
        "favicon": "Favicon",
        "faviconDesc": "Browser tab icon",
        "pwaIcon": "PWA Icon 192",
        "pwaIconDesc": "Mobile installation (192x192)",
        "pwaIcon512": "PWA Icon 512",
        "pwaIcon512Desc": "Mobile splash screen (512x512)",
        "appleIcon": "Apple Touch Icon",
        "appleIconDesc": "iOS home screen (180x180)",
        "ogImage": "Open Graph",
        "ogImageDesc": "Social sharing",
        "colors": "Theme Colors",
        "primaryColor": "Primary Color",
        "secondaryColor": "Secondary Color"
      },
      "security": {
        "title": "Security",
        "maxLoginAttempts": "Max Login Attempts",
        "attemptsRange": "Between 3 and 10 attempts",
        "sessionTimeout": "Session Timeout (minutes)",
        "timeoutRange": "Between 30 and 1440 minutes (24h)",
        "resellerMaxTestHours": "Test Limit (Resellers)",
        "hours": "hours",
        "resellerMaxTestHoursHelp": "Maximum time in hours (1-72). Admin has no limit.",
        "resellerLimitInfo": "ℹ️ Test Account Control",
        "resellerLimitInfo1": "Resellers can create tests up to {hours} hours",
        "resellerLimitInfo2": "Admin and Super Admin have no limit (up to 72h)",
        "resellerLimitInfo3": "Setting applied immediately after saving"
      },
      "backup": {
        "title": "Automatic Backup",
        "enableBackup": "Enable Automatic Backup",
        "enableBackupDesc": "Database backup will be sent via Telegram at configured interval",
        "interval": "Interval (minutes)",
        "intervalDesc": "How often to backup (ex: 1440 = 24h)",
        "telegramBot": "Telegram Bot Token",
        "telegramBotPlaceholder": "123456:ABC-DEF...",
        "telegramChat": "Telegram Chat ID",
        "telegramChatPlaceholder": "-100123456789",
        "restoreBackup": "Restore Backup",
        "selectFile": "Select backup file",
        "acceptedFormats": "Accepted formats: .enc, .sql",
        "invalidFile": "Invalid file. Use only .enc or .sql",
        "decryptPassword": "Decryption password",
        "decryptPasswordPlaceholder": "Enter the backup encryption password",
        "decryptPasswordHelp": "Same password used when the backup was encrypted",
        "noPasswordForSql": ".sql files do not require a password (e.g. import from another panel or unencrypted backup).",
        "automaticBackup": "Automatic Backup",
        "createNow": "Backup Now",
        "creating": "Creating backup...",
        "confirmCreate": "Create a manual backup now?\n\nThe backup will be saved on the server.",
        "createBackupTitle": "Create Manual Backup",
        "createSuccess": "Backup created successfully!",
        "createError": "Error creating backup",
        "dragFile": "Drag the file here or click to select",
        "confirmRestore": "I confirm I want to DELETE all current data.",
        "confirmRestoreDesc": "This action cannot be undone.",
        "confirmRestoreFinal": "FINAL CONFIRMATION\n\nAll current data will be PERMANENTLY DELETED.\n\nDo you really want to continue?",
        "restoreWarning": "⚠️ Confirm Restore",
        "restore": "Restore Backup",
        "restoring": "Restoring...",
        "restoreSuccess": "Backup restored successfully! You will be logged out.",
        "restoreError": "Error restoring backup",
        "encryptionPassword": "Encryption Password",
        "encryptionPasswordPlaceholder": "Enter password to encrypt backups (minimum 8 characters)",
        "encryptionPasswordHelp": "Password used to encrypt backup files. Keep it safe! Required to restore backups.",
        "criticalOperationTitle": "⚠️ CRITICAL OPERATION",
        "criticalOperationItem1": "This operation will DELETE all current data",
        "criticalOperationItem2": "Make a backup before restoring",
        "criticalOperationItem3": "You will be logged out after restore",
        "restoreProgressWait": "Please wait. This may take a few minutes. Do not close this page."
      },
      "cleanup": {
        "title": "Automatic Cleanup",
        "enableCleanup": "Enable Device Cleanup",
        "enableCleanupDesc": "Remove inactive devices automatically",
        "minutes": "Inactivity (minutes)",
        "minutesDesc": "Remove after how many minutes without access"
      },
      "advanced": {
        "title": "Advanced",
        "maintenanceMode": "Maintenance Mode",
        "maintenanceModeDesc": "Disable panel access (super admin only)",
        "autoSales": "Global Auto Sales",
        "autoSalesDesc": "Enable auto sales for all admins"
      },
      "templates": {
        "title": "Message Templates",
        "description": "Customize messages after creating accounts, resellers, tests, and auto-sales. Use variables for dynamic data and {br} for line breaks between blocks.",
        "accountLabel": "Account Message",
        "resellerLabel": "Reseller Message",
        "testLabel": "Test Account Message",
        "whatsappFormat": "WhatsApp format",
        "telegramFormat": "Telegram format",
        "salesSectionTitle": "Auto-sales (public page)",
        "salesSectionDesc": "One template per type — used on «Copy credentials» after PIX payment.",
        "salesAccountLabel": "Account message (sales)",
        "salesResellerLabel": "Reseller message (sales)",
        "salesAccountRenewalLabel": "Account renewal (sales)",
        "salesResellerRenewalLabel": "Reseller renewal (sales)",
        "salesResellerCreditsLabel": "Credits purchase (sales)",
        "availableVars": "Available variables (click to insert):",
        "formattingVarsHint": "Use {br} for one blank line between blocks. Empty lines in the editor also work. Empty fields (Store, App, etc.) are omitted automatically.",
        "resetDefault": "Reset to default",
        "preview": "Preview",
        "previewWhatsapp": "WhatsApp preview",
        "previewTelegram": "Telegram preview",
        "previewPlain": "Plain text preview",
        "appLinkLabel": "App link",
        "appLinkHint": "Used in {app_link} across all templates. If empty, the app line is omitted from messages.",
        "appLinkPlaceholder": "https://play.google.com/store/apps/details?id=...",
        "customizedBadge": "Customized",
        "inheritedFromMaster": "Inherited from {name}",
        "inheritedFromGlobal": "Inherited from global panel",
        "clearCustomization": "Clear customization",
        "clearCustomizationSuccess": "Customization removed — inheriting from master again.",
        "clearCustomizationLocal": "Local changes discarded — inherited value restored.",
        "editorHint": "The default text is pre-filled so you can edit it. Use «Reset to default» to restore the original system template."
      },
      "unsavedChanges": "You have unsaved changes",
      "saveSuccess": "Settings saved successfully!",
      "saveError": "Error saving settings",
      "changesDiscarded": "Changes discarded",
      "uploadSuccess": "File uploaded successfully!",
      "uploadError": "Error uploading file",
      "removeIcon": "Remove Icon",
      "removeIconConfirm": "Are you sure? Default icon will be used.",
      "removeSuccess": "Icon removed successfully"
    },
    "pwa": {
      "installTitle": "Install App",
      "manualInstallToastTitle": "Manual install",
      "manualInstallToast": "Use the browser menu (⋮) → Install / App / Install this page.",
      "manualInstallHint": "No automatic prompt: in Chrome or Edge open the menu (⋮), then Install or “Install as app” / “Install this page”. Other browsers may use the side menu or Share.",
      "httpsHint": "Desktop install requires HTTPS in production (localhost is an exception).",
      "installMessage": "Install Veltrix Panel as an app",
      "installButton": "Install Now",
      "installing": "Installing...",
      "benefit1": "Quick access without opening browser",
      "benefit2": "Works offline",
      "benefit3": "Real-time notifications",
      "updateTitle": "Update available",
      "updateMessage": "A new version is ready to be installed",
      "updateButton": "Update Now"
    }
  },
  "messageTemplates": {
    "copyWhatsapp": "Copy (WhatsApp)",
    "copyTelegram": "Copy (Telegram)",
    "copied": "Copied!",
    "copySuccess": "Message copied!",
    "copyError": "Copy failed",
    "emptyTemplate": "Configure the template in Settings → Messages."
  },
  "auditUserTypes": {
    "super_admin": "Super Admin",
    "admin": "Admin",
    "reseller": "Reseller",
    "sub_reseller": "Sub-reseller",
    "system": "System",
    "info": "Info",
    "warning": "Warning",
    "error": "Error",
    "critical": "Critical"
  },
  "auditEntities": {
    "users": "Account",
    "resellers": "Reseller",
    "categories": "Category",
    "servers": "Server",
    "payments": "Payment",
    "panel_settings": "Setting",
    "admin_users": "Administrator",
    "device_ids": "Devices",
    "system": "System"
  },
  "auditActions": {
    "payment_created": "Payment created",
    "setting_updated": "Setting updated",
    "settings_bulk_updated": "Bulk settings",
    "server_created": "Server created",
    "server_updated": "Server updated",
    "server_deleted": "Server removed",
    "automation_toggled": "Automation toggled",
    "reseller_created": "Reseller created",
    "reseller_updated": "Reseller updated",
    "reseller_deleted": "Reseller removed",
    "reseller_credits_returned": "Credits returned",
    "reseller_credits_added": "Credits added",
    "reseller_credits_deducted": "Credits deducted",
    "reseller_credit_deducted": "Credit deducted (payment)",
    "reseller_slots_returned": "Slots returned",
    "reseller_subscription_renewed": "Subscription renewed",
    "reseller_hierarchy_deactivated": "Hierarchy deactivated",
    "reseller_hierarchy_activated": "Hierarchy reactivated",
    "reseller_created_via_payment": "Reseller via payment",
    "reseller_renewed_via_payment": "Renewal via payment",
    "reseller_credits_purchased": "Credits purchased",
    "account_created": "Account created",
    "account_created_from_plan": "Account from plan",
    "account_updated": "Account updated",
    "account_deleted": "Account removed",
    "account_renewed": "Account renewed",
    "account_status_toggled": "Account status",
    "category_created": "Category created",
    "category_updated": "Category updated",
    "category_deleted": "Category removed",
    "category_set_default": "Default category",
    "category_migration": "Category migration",
    "branding_updated": "Branding updated",
    "branding_deleted": "Branding removed",
    "branding_settings_updated": "Branding settings",
    "devices_cleanup": "Device cleanup",
    "admin_login": "Login",
    "admin_logout": "Logout",
    "admin_created": "Admin created",
    "failed_login_attempt": "Login failed",
    "worker_backup_success": "Automatic backup",
    "worker_backup_error": "Automatic backup (error)",
    "worker_device_cleanup": "Device cleanup",
    "worker_device_cleanup_error": "Device cleanup (error)",
    "worker_audit_log_cleanup": "Audit log cleanup",
    "worker_audit_log_cleanup_error": "Audit log cleanup (error)",
    "worker_check_expired": "Expired check",
    "worker_check_expired_error": "Expired check (error)"
  },
  "auditMessages": {
    "genericWithEntity": "{action} — {entity}",
    "payment_created": "Payment #{entityId} recorded",
    "setting_updated": "Panel setting changed",
    "settings_bulk_updated": "Multiple settings updated",
    "server_created": "Server #{entityId} created",
    "server_updated": "Server #{entityId} updated",
    "server_deleted": "Server #{entityId} removed",
    "automation_toggled": "Automation state changed",
    "reseller_created": "Reseller #{entityId} created",
    "reseller_updated": "Reseller #{entityId} updated",
    "reseller_deleted": "Reseller #{entityId} removed",
    "reseller_credits_returned": "{credits_returned} credit(s) returned to parent reseller",
    "reseller_credits_added": "+{amount} credit(s); balance: {new_balance}",
    "reseller_credits_deducted": "Credits deducted from reseller #{entityId}",
    "reseller_credit_deducted": "Deduction of ${amount} — {detail}",
    "reseller_slots_returned": "{slots_returned} slot(s) returned",
    "reseller_subscription_renewed": "Reseller #{entityId} subscription renewed",
    "reseller_hierarchy_deactivated": "Reseller #{entityId} and downline deactivated",
    "reseller_hierarchy_activated": "Reseller #{entityId} and downline reactivated",
    "reseller_created_via_payment": "Sub-reseller {username} created via PIX (type: {type})",
    "reseller_renewed_via_payment": "Reseller #{resellerId} renewed (+{days} days, limit {limit})",
    "reseller_credits_purchased": "Reseller #{resellerId}: +{credits} credit(s); balance {balance}",
    "account_created": "Account {username} created",
    "account_created_from_plan": "Account created from plan (ID {entityId})",
    "account_updated": "Account #{entityId} updated",
    "account_deleted": "Account #{entityId} removed",
    "account_renewed": "Account #{entityId} renewed",
    "account_status_toggled": "Account #{entityId} status changed",
    "category_created": "Category created (ID {entityId})",
    "category_updated": "Category #{entityId} updated",
    "category_deleted": "Category #{entityId} removed",
    "category_set_default": "Category #{entityId} set as default",
    "category_migration": "Accounts migrated between categories",
    "branding_updated": "Branding image or icon updated",
    "branding_deleted": "Branding item removed (type: {type})",
    "branding_settings_updated": "Branding settings saved",
    "devices_cleanup": "{count} device(s) removed in manual cleanup",
    "admin_login": "Session started",
    "admin_logout": "Session ended",
    "admin_created": "New administrator (ID {entityId})",
    "failed_login_attempt": "Failed login for \"{username}\" (IP {ip})",
    "worker_check_expired": "{expired_accounts} account(s) and {expired_resellers} reseller(s) expired; {slots_returned} slot(s) returned",
    "worker_check_expired_error": "Expired check failed: {error}",
    "worker_device_cleanup": "{devices_deleted} device(s) removed",
    "worker_device_cleanup_error": "Device cleanup failed: {error}",
    "worker_audit_log_cleanup": "{logs_deleted} log(s) removed (retention: {retention_days} days)",
    "worker_audit_log_cleanup_error": "Audit log cleanup failed: {error}",
    "worker_backup_success": "Backup {filename} completed ({size_mb} MB)",
    "worker_backup_error": "Automatic backup failed: {error}"
  },
  "auditDetails": {
    "account_created_via_pix": "account created via PIX payment"
  },
  "viewMessages": {
    "profile": {
      "invalidFormat": "Invalid format. Use JPG or PNG",
      "fileTooLarge": "File too large. Maximum: {max} MB when selecting.",
      "imageTooLarge": "Image too large. Maximum: 512x512 pixels",
      "avatarUpdatedSuccess": "Avatar updated successfully!",
      "avatarRemovedSuccess": "Avatar removed successfully!",
      "uploadError": "Upload error",
      "removeAvatarError": "Error removing avatar",
      "enterPassword": "Enter the new password!",
      "passwordMismatch": "Passwords do not match!",
      "passwordChangeSuccess": "Password changed successfully!",
      "enterCurrentPassword": "Enter your current password to change it!",
      "confirmRemoveAvatar": "Are you sure you want to remove your profile photo?",
      "updateProfileError": "Error updating profile"
    },
    "backup": {
      "configureTelegram": "Set up the Telegram bot and save the settings",
      "autoBackupDisabled": "Automatic backup disabled",
      "enterBotToken": "Enter the Bot Token",
      "enterChatId": "Enter the Chat ID",
      "configureEncryptionPassword": "Set an encryption password (minimum 8 characters)",
      "encryptionPasswordTooShort": "Encryption password must be at least 8 characters",
      "configSavedSuccess": "Backup settings saved successfully!",
      "configSaveError": "Error saving backup settings",
      "backupStarted": "Backup started! You will receive the file on Telegram shortly.",
      "backupError": "Error running backup",
      "selectValidEncFile": "Please select a valid .enc file",
      "restoreSuccess": "Backup restored successfully!\n\nYou will be logged out. Please log in again.",
      "restoreError": "Error restoring backup",
      "confirmBackupTitle": "Run Backup Now?",
      "confirmBackupMessage": "A full database backup will be generated and sent to the configured Telegram. Continue?",
      "confirmRestoreTitle": "⚠️ RESTORE BACKUP",
      "confirmRestoreMessage": "WARNING: All current data will be REPLACED by the backup data. This action CANNOT be undone. Continue?",
      "passwordNotConfigured": "⚠️ Backup password not configured!\n\nPlease set the encryption password above and save the settings before making a backup.",
      "incompleteConfiguration": "❌ Incomplete configuration!\n\n{error}\n\nPlease check the settings above and try again.",
      "noBackupRun": "No backup performed",
      "confirmManualBackupTitle": "Confirm Manual Backup",
      "confirmManualBackupMessage": "Do you want to make a manual backup now?\n\nThe backup will be encrypted and sent to Telegram."
    },
    "branding": {
      "loadingError": "Error loading branding settings",
      "iconUpdatedSuccess": "Icon updated successfully!",
      "iconSizesGenerated": "{count} sizes generated automatically!",
      "iconUploadError": "Error uploading icon",
      "iconRemovedSuccess": "Icon removed successfully!",
      "iconRemoveError": "Error removing icon",
      "pwaUpdatedSuccess": "PWA settings updated!",
      "pwaUpdateError": "Error updating PWA settings"
    },
    "dashboard": {
      "statsLoadError": "Error loading dashboard statistics",
      "categoriesLoadError": "Error loading categories"
    },
    "accounts": {
      "loadError": "Error loading accounts",
      "categoriesLoadError": "Error loading categories",
      "statusUpdated": "Status updated!",
      "deleteSuccess": "Account deleted successfully!",
      "bulkDeleteSuccess": "{deleted} of {total} account(s) deleted successfully!",
      "bulkDeleteNone": "No accounts were deleted",
      "devicesRemovedSuccess": "Devices removed successfully!",
      "enterNewPassword": "Enter a new password to update",
      "updateSuccess": "Account updated successfully!",
      "loadDetailsError": "Error loading account details",
      "credentialsCopied": "Credentials copied!",
      "expiredBeforeEnable": "Account expired! Renew before enabling.",
      "createError": "Error creating account",
      "createTestError": "Error creating test account",
      "minDaysError": "Minimum validity is {min} days",
      "selectPlanAndCategory": "Select a plan and a category",
      "insufficientCreditsPlan": "Insufficient credits! You have {available}, need {needed} for this plan ({days} days)",
      "insufficientCreditsMonths": "Insufficient credits! You have {available}, need {needed}",
      "statusUpdateError": "Error updating status",
      "deleteError": "Error deleting account",
      "bulkDeleteError": "Error deleting some accounts",
      "clearDevicesError": "Error clearing devices",
      "copyCredentialsError": "Error copying credentials",
      "accountNotFound": "Account not found",
      "buildMessageError": "Could not build the message",
      "selectCategory": "Select a category"
    },
    "accountPlans": {
      "loadError": "Error loading plans",
      "createSuccess": "Plan created successfully!",
      "updateSuccess": "Plan updated successfully!",
      "deleteSuccess": "Plan deleted successfully!",
      "saveError": "Error saving plan",
      "deleteError": "Error deleting plan"
    },
    "resellers": {
      "creditsAddedSuccess": "Credits added successfully!",
      "subscriptionAdjustedSuccess": "Subscription adjusted successfully!",
      "processError": "Error processing operation",
      "deleteSuccess": "Reseller deleted successfully!",
      "deleteError": "Error deleting reseller",
      "fillRequiredFields": "Fill in username, email and password",
      "loadError": "Error loading resellers",
      "statusUpdated": "Status updated!",
      "statusUpdateError": "Error updating status",
      "bulkDeleteSuccess": "{deleted} of {total} reseller(s) deleted successfully!",
      "bulkDeleteNone": "No resellers were deleted",
      "bulkDeleteError": "Error deleting some resellers"
    },
    "resellerPlans": {
      "loadError": "Error loading plans",
      "deleteSuccess": "Plan deleted successfully!",
      "deleteError": "Error deleting plan"
    },
    "checkuser": {
      "statsLoadError": "Error loading CheckUser statistics",
      "configSaved": "Settings saved successfully!",
      "urlCopied": "URL copied!",
      "endpointResponding": "Endpoint {name} responding! ✅\n\n{details}",
      "endpointProblem": "Endpoint {name} with problem:\n\n{details}",
      "endpointTestError": "Error testing endpoint: {error}",
      "devicesRemovedSuccess": "Devices removed successfully!",
      "cleanupManualSuccess": "Cleanup completed: {removed} device(s) removed.",
      "cleanupManualError": "Error running manual cleanup.",
      "configSaveError": "Error saving settings.",
      "devicesClearError": "Error clearing devices."
    },
    "settings": {
      "loadError": "Error loading settings"
    },
    "logs": {
      "loadError": "Error loading logs",
      "logsCleared": "{count} log(s) removed!",
      "clearError": "Error clearing logs"
    },
    "automations": {
      "selectPaymentMethodsWarning": "Select at least one payment method",
      "paymentMethodsUpdatedSuccess": "Payment methods updated successfully",
      "paymentMethodsSaveError": "Error saving payment methods",
      "urlCopied": "URL copied!",
      "categorySaveError": "Error saving category",
      "featureDisabled": "Disabled",
      "featureEnabledWithUrl": "Enabled! URL: {url}",
      "updateError": "Error updating",
      "goToAccountPlansTitle": "Go to Account Plans?",
      "goToResellerPlansTitle": "Go to Reseller Plans?",
      "deleteGatewayConfirm": "Are you sure you want to remove this gateway?",
      "deleteGatewayTitle": "Remove Gateway",
      "gatewayRemoved": "Gateway removed!",
      "gatewayRemoveError": "Error removing gateway",
      "gatewayUpdatedSuccess": "Gateway and methods updated!",
      "gatewayAddedSuccess": "Gateway added! Click \"Configure Methods\" to select payment methods.",
      "gatewaySaveError": "Error saving gateway"
    },
    "auth": {
      "loginFallbackError": "Login failed. Check your credentials."
    },
    "payment": {
      "usernameValidation": "Username must be 3-32 characters (letters and numbers only)",
      "createPaymentError": "Error creating payment. Try again."
    },
    "servers": {
      "loadError": "Error loading servers: {error}",
      "categoriesLoadWarning": "Could not load categories. Using default category.",
      "createSuccess": "Server added successfully!",
      "createError": "Error adding server",
      "createErrorWithTips": "{message}\n\n💡 Tips:\n{tips}",
      "invalidApiPort": "Invalid API port. Must be between 1024 and 65535",
      "duplicateServer": "A server with this IP and port already exists",
      "updateSuccess": "Server updated successfully!",
      "updateError": "Error updating server",
      "apiOnlineSuccess": "API is online and working!",
      "apiNotResponding": "API is not responding",
      "apiNotInstalledInfo": "API is not installed",
      "apiStatusCheckError": "Error checking API status",
      "deleteSuccess": "Server deleted successfully!",
      "deleteError": "Error deleting server",
      "apiUninstalledBeforeDelete": "API uninstalled before deletion",
      "deleteContinueDespiteApiError": "Continuing deletion despite API uninstall error",
      "apiUninstallSuccess": "API uninstalled successfully!",
      "apiUninstallError": "Error uninstalling API",
      "ssh2ExtensionError": "SSH2 extension is not installed.\n\n{instructions}\n\n{note}",
      "unknownError": "Unknown error"
    },
    "categories": {
      "loadError": "Error loading categories",
      "createSuccess": "Category created successfully",
      "updateSuccess": "Category updated successfully",
      "saveError": "Error saving category",
      "alreadyDefault": "This category is already the default",
      "setDefaultSuccess": "Category \"{name}\" set as default!",
      "setDefaultError": "Error setting default category",
      "migrateSuccess": "{count} {entity} migrated successfully!",
      "migrateError": "Error migrating",
      "deleteSuccess": "Category deleted successfully"
    },
    "coupons": {
      "loadError": "Error loading coupons",
      "createSuccess": "Coupon created!",
      "updateSuccess": "Coupon updated!",
      "saveError": "Error saving coupon",
      "deactivated": "Coupon deactivated",
      "activated": "Coupon activated",
      "toggleError": "Error updating coupon",
      "deleteSuccess": "Coupon deleted!",
      "deleteError": "Error deleting coupon"
    }
  },
  "apiMessages": {
    "emailPasswordRequired": "Username/email and password are required",
    "invalidCredentials": "Invalid credentials",
    "notAuthenticated": "Not authenticated",
    "invalidToken": "Invalid token",
    "resellerInactive": "Your reseller account is inactive. Contact support.",
    "resellerExpired": "Your reseller subscription has expired. Renew to continue.",
    "resellerNotFound": "Reseller not found",
    "loginSuccess": "Login successful",
    "logoutSuccess": "Logout successful",
    "currentPasswordRequired": "Current password is required",
    "newPasswordRequired": "New password is required",
    "currentPasswordWrong": "Current password is incorrect",
    "passwordChanged": "Password changed successfully",
    "noFileUploaded": "No file uploaded or upload error",
    "fileTooLarge": "File too large. Maximum: 3MB after crop",
    "fileTooLarge3mb": "File too large. Maximum: 3MB after crop",
    "invalidFileType": "Invalid file type. Use JPG or PNG",
    "imageProcessingError": "Error processing image",
    "imageTooLarge": "Image too large. Maximum: 512x512 pixels",
    "avatarUpdated": "Avatar updated successfully",
    "avatarRemoved": "Avatar removed successfully",
    "accountCreated": "Account created successfully",
    "accountUpdated": "Account updated successfully",
    "accountDeleted": "Account deleted successfully",
    "accountRenewed": "Account renewed successfully",
    "accountCreatedFromPlan": "Account created from plan",
    "planCategoryRequired": "Fields plan_id and category_id are required",
    "noValidIds": "No valid IDs provided",
    "errorListingAccounts": "Error listing accounts",
    "errorUpdatingAccount": "Error updating account",
    "errorDeletingAccount": "Error deleting account",
    "planCreated": "Plan created successfully",
    "planUpdated": "Plan updated successfully",
    "planDeleted": "Plan deleted successfully",
    "noPermissionEditPlan": "You do not have permission to edit this plan",
    "noPermissionDeletePlan": "You do not have permission to delete this plan",
    "resellerNoCategory": "Reseller does not have a linked category",
    "errorFetchingData": "Error fetching data",
    "usernameInvalid": "Username must be 3-50 alphanumeric characters",
    "emailInvalid": "Invalid email",
    "passwordTooShort": "Password must be at least 4 characters",
    "usernameExists": "Username already exists",
    "emailExists": "Email already registered",
    "adminCreated": "Administrator created successfully",
    "adminUpdated": "Administrator updated successfully",
    "adminDeleted": "Administrator deleted successfully",
    "cannotChangeSuperAdmin": "Cannot change super_admin role",
    "cannotDeleteSuperAdmin": "Cannot delete super_admin",
    "cannotDeleteSelf": "Cannot delete your own account",
    "cannotDeactivateSelf": "You cannot deactivate your own account",
    "cannotDeactivateSuperAdmin": "Cannot deactivate super_admin",
    "errorListingAdmins": "Error listing administrators",
    "couponCodeRequired": "Coupon code is required",
    "invalidDiscount": "Invalid discount",
    "couponExists": "Coupon with this code already exists",
    "couponCreated": "Coupon created successfully",
    "couponInvalid": "Invalid or expired coupon",
    "usernameRequired": "Username is required",
    "usernameOrEmailExists": "Username or email already exists",
    "serverCreated": "Server created successfully",
    "serverUpdated": "Server updated successfully",
    "serverDeleted": "Server deleted successfully",
    "syncStarted": "Sync started. You will be notified when it finishes.",
    "invalidServerId": "Invalid server ID",
    "userNotIdentified": "User not identified",
    "serverNotFound": "Server not found",
    "jobNotFound": "Job not found or expired",
    "jobIdRequired": "job_id is required",
    "categoryCreated": "Category created successfully",
    "categoryUpdated": "Category updated successfully",
    "categoryDeleted": "Category deleted successfully",
    "settingsSaved": "Settings saved successfully",
    "backupSuccess": "Backup completed successfully",
    "resellerCreated": "Reseller created successfully",
    "resellerUpdated": "Reseller updated successfully",
    "resellerDeleted": "Reseller deleted successfully",
    "testAccountCreated": "Test account created successfully",
    "subscriptionExpired": "Your subscription has expired. Renew to continue.",
    "userNotFound": "User not found",
    "resellersOnly": "Resellers only",
    "error": "Error",
    "accountStatusIs": "Your account has an irregular status. Contact support.",
    "resellerAccountStatusIs": "Your reseller account has an irregular status. Contact support.",
    "resellerExpiredAt": "Your reseller subscription has expired. Renew to continue creating accounts.",
    "noCreditsAvailable": "No credits available.",
    "loginLimitReached": "Login limit reached.",
    "noServersInCategory": "No servers found in the selected category.",
    "errorDeletingAccounts": "Error deleting accounts.",
    "loginError": "Login error.",
    "errorFetchingUser": "Error fetching user.",
    "errorRenewingToken": "Error renewing token.",
    "errorUpdatingProfile": "Error updating profile.",
    "errorListingPlans": "Error listing plans.",
    "invalidIds": "Invalid IDs.",
    "creditResellerRestriction": "Credit-type resellers have editing restrictions.",
    "enterNewPassword": "Enter a new password or WhatsApp to update."
  },
  "publicTest": {
    "title": "Free Trial",
    "subtitle": "Generate your {hours}h free trial",
    "unavailable": "Public trials are not available at the moment.",
    "loadError": "Could not load the trial page.",
    "invalidLink": "Invalid trial link.",
    "emailLabel": "Email",
    "emailPlaceholder": "you{'@'}gmail.com",
    "phoneLabel": "WhatsApp / Telegram",
    "phonePlaceholder": "+1 555 000 0000",
    "optional": "optional",
    "contactHelp": "Required email from a known provider (Gmail, Outlook, etc.). WhatsApp/Telegram are optional. {cooldown}h cooldown per email. Credentials are delivered by email only.",
    "emailRequired": "Enter a valid email.",
    "emailNotTrusted": "Use an email from a known provider (Gmail, Outlook, Yahoo, iCloud, Proton, etc.).",
    "contactRequired": "Enter a valid email.",
    "includeV2ray": "Include V2Ray access",
    "generateButton": "Generate free trial",
    "generating": "Generating trial...",
    "createError": "Error generating trial. Please try again.",
    "cooldownActive": "You already generated a trial recently. Try again in about {hours}h.",
    "successTitle": "Test ready! Check your email",
    "validForHours": "Valid for {hours} hours",
    "expiresAt": "Expires at",
    "copyError": "Could not copy automatically.",
    "shareMessage": "Share message",
    "copyShareMessage": "Copy message",
    "emailSentTo": "We sent the credentials to {email}",
    "checkSpamHint": "Check your inbox and spam folder. Credentials are never shown on this page for security."
  },
  "settingsPage": {
    "security": {
      "publicTestsTitle": "Public Trials",
      "publicTestsGloballyEnabled": "Enable public trials on the panel",
      "publicTestsGloballyEnabledHelp": "Allows sellers to enable the public free trial page.",
      "publicTestDurationHours": "Public trial duration",
      "publicTestCooldownHours": "Contact cooldown",
      "publicTestCooldownHelp": "The same email can only generate a new trial after this period (global).",
      "publicTestIncludeV2ray": "Offer V2Ray option on the public page",
      "expirationTitle": "Expiration notifications",
      "expirationNotifyEnabled": "Notify in bell (accounts and resellers)",
      "expirationNotifyEnabledHelp": "The worker sends bell alerts when accounts or subscriptions are about to expire or have expired.",
      "expirationEmailEnabled": "Also send by email",
      "expirationEmailEnabledHelp": "Requires configured SMTP. Email goes to the responsible admin/reseller.",
      "expirationWarningDays": "Advance warning days",
      "expirationWarningDaysHelp": "Comma-separated (e.g. 7,3,1). The worker warns on those days before expiration.",
      "expirationAccountEmailTemplate": "Email template — account",
      "expirationResellerEmailTemplate": "Email template — reseller",
      "expirationEmailVars": "Variables: {username}, {expires_at}, {days_remaining}, {state_message}, {renewal_line}, {panel_name}, {br}"
    }
  },
  "publicApiDocs": {
    "title": "Public API Documentation",
    "subtitle": "Endpoints for sales, renewal, trials and recovery — licensed-domain PWA session or per-seller API token",
    "authNote": "/api/public/* routes require a session cookie (licensed-domain PWA with valid Origin) or X-Public-Api-Token header (server-side integrations). Each admin/reseller has their own token, valid only for their slug. CheckUser and webhooks are not gated.",
    "authPwaTitle": "PWA (browser)",
    "authPwaDesc": "POST /api/public/session/bootstrap sets an HttpOnly cookie. Requires a valid license on the domain and matching Origin/Referer. Used by the official frontend.",
    "authTokenTitle": "External integration (Postman, bot, server)",
    "authTokenDesc": "X-Public-Api-Token header generated below. One token per account (admin/reseller). On routes with {slug}, the slug must belong to the token owner.",
    "tokenManagementTitle": "Your public API token",
    "postmanVariablesHint": "Postman collection: set public_api_token after generating your token. Use sales_slug from your account.",
    "sessionOrToken": "PWA session (licensed domain) or X-Public-Api-Token",
    "pwaBootstrapOnly": "PWA bootstrap — exempt from guard (license + origin required)",
    "noGuard": "No guard (CheckUser / webhooks)",
    "tokenOnly": "X-Public-Api-Token only — PWA session not accepted.",
    "baseUrl": "API base",
    "yourSlug": "Your sales slug (examples use this slug)",
    "copy": "Copy",
    "copied": "Copied!",
    "rateLimit": "Limit",
    "queryParams": "Query params",
    "requestBody": "Request body (JSON)",
    "responseBody": "Response (JSON)",
    "queryHints": {
      "paymentMethodsAmount": "Filters methods whose min_amount/max_amount covers the amount (e.g. ?amount=29.90). Recommended before checkout.",
      "renewalSellerId": "Seller ID returned by POST /renewal/search (required)."
    },
    "examples": {
      "pix": "PIX (Brazil)",
      "creditCard": "Card — Mercado Pago BR",
      "creditCardAr": "Card — Mercado Pago AR (DNI)",
      "cashTicket": "Cash ticket (e.g. OXXO MX)",
      "pixCreated": "PIX created (pending)",
      "cardApproved": "Card approved",
      "cardPending": "Card under review",
      "cashCreated": "Cash ticket created",
      "pending": "Status pending",
      "provisioning": "Approved — provisioning account",
      "approvedAccount": "Approved — account credentials"
    },
    "guides": {
      "paymentOverview": {
        "title": "Payment flow",
        "intro": "Common steps for account sales, reseller sales and renewal.",
        "bullet1": "GET payment-methods (with ?amount=) → pick gateway_id and payment_method_type.",
        "bullet2": "PIX/card require customer_name (first + last), customer_email and payer document.",
        "bullet3": "POST payment → poll GET /payment/{paymentId}/status with the returned payment_id.",
        "bullet4": "Approved card may return status approved immediately; account may take seconds (provisioning: true).",
        "bullet5": "Cash tickets (OXXO, Rapipago…) return payment_url — redirect the customer to pay offline."
      },
      "creditCardFlow": {
        "title": "Credit card (Mercado Pago)",
        "intro": "Card tokenization happens on the client, directly with Mercado Pago — never send card number/CVV to the panel.",
        "bullet1": "Get mp_public_key and mp_credential_environment from GET payment-methods → data.gateway.",
        "bullet2": "On checkout, load https://www.mercadopago.com/v2/security.js (view=checkout) and read MP_DEVICE_SESSION_ID or #deviceId — required in production (APP_USR).",
        "bullet3": "On the frontend, POST https://api.mercadopago.com/v1/card_tokens?public_key=... with Public Key + card data.",
        "bullet4": "Optional: GET /v1/payment_methods/installments?public_key=&bin=&amount= for installments and issuer_id.",
        "bullet5": "Send to the panel: card_token, mp_payment_method_id, installments and cardholder_name (name on card).",
        "bullet6": "Send mp_device_session_id (antifraud) and mp_public_key_used (same Public Key used to tokenize).",
        "bullet7": "issuer_id and issuer_verified are optional (from BIN/installments lookup).",
        "bullet8": "If rejected → success:false; if approved/in_process → poll GET /payment/{paymentId}/status until provisioning=false."
      },
      "payerDocuments": {
        "title": "Payer document by region",
        "intro": "Field customer_cpf accepts the local document. Use identification_type when different from the region default.",
        "bullet1": "BR → CPF (11 digits, type CPF). PIX is Brazil-only.",
        "bullet2": "AR → DNI (7–8 digits). PE → DNI (8 digits).",
        "bullet3": "MX → CURP (18 alphanumeric characters).",
        "bullet4": "CL → RUT (8–9 characters, includes check digit K).",
        "bullet5": "CO → CC (6–10 digits). UY → CI (6–8 digits).",
        "bullet6": "GET payment-methods returns gateway.payer_document (type, min_len, max_len, charset) and payer_document_rules (payment or customer per method).",
        "bullet7": "Asaas/EFI (BR): document is always CPF."
      }
    },
    "pages": {
      "accountSales": "Public account store",
      "resellerSales": "Public reseller store",
      "renewal": "Public renewal",
      "publicTest": "Free public trials",
      "credentialRecovery": "Credential recovery"
    },
    "sections": {
      "auth": {
        "title": "Authentication",
        "description": "PWA session bootstrap and per-seller token management for external integrations."
      },
      "accountSales": {
        "title": "Account sales",
        "description": "Plans, PIX/card payment and message templates per seller slug."
      },
      "resellerSales": {
        "title": "Reseller sales",
        "description": "Reseller plans, payment and username/email validation."
      },
      "renewal": {
        "title": "Public renewal",
        "description": "Customer finds account by username/UUID and pays to renew."
      },
      "publicTest": {
        "title": "Public trials",
        "description": "Free trial via email (PWA/session) or direct credentials in JSON (token owner slug only)."
      },
      "credentialRecovery": {
        "title": "Credential recovery",
        "description": "Customer enters the registered email and receives all linked VPN credentials (username, password, status, validity) in one email."
      },
      "payment": {
        "title": "Payment (shared)",
        "description": "Status polling (PIX, card and cash) and cancellation of pending payments."
      },
      "checkuser": {
        "title": "CheckUser",
        "description": "DTunnel and Conecta4G app integration (root panel routes)."
      }
    },
    "endpoints": {
      "auth": {
        "sessionBootstrap": {
          "description": "Starts public session (HttpOnly cookie) for the PWA. Body: context (sales, test, renewal…) and optional slug.",
          "rateLimit": "30 req/min"
        }
      },
      "accountSales": {
        "salesPlans": {
          "description": "Lists active account plans for the seller.",
          "rateLimit": "60 req/min"
        },
        "salesPaymentMethods": {
          "description": "Active seller methods + gateway object (provider, region, currency, mp_public_key, mp_credential_environment, payer_document, payer_document_rules). Use ?amount= to filter by plan price.",
          "rateLimit": "60 req/min"
        },
        "salesPayment": {
          "description": "Creates payment for account purchase. payment_method_type: pix | credit_card | oxxo | rapipago | … (per region). Common fields: plan_id, gateway_id, customer_name, customer_email, customer_cpf (document), identification_type (optional).",
          "notes": "MP card: card_token, mp_payment_method_id, installments, cardholder_name, mp_device_session_id (production), mp_public_key_used; issuer_id optional. Public reseller sale requires reseller_username, reseller_email and reseller_password (min. 6).",
          "rateLimit": "10 req/min"
        },
        "salesMessageTemplates": {
          "description": "Post-sale message templates for the seller.",
          "rateLimit": "60 req/min"
        }
      },
      "resellerSales": {
        "resellerPlans": {
          "description": "Lists reseller plans.",
          "rateLimit": "60 req/min"
        },
        "resellerPaymentMethods": {
          "description": "Same format as sales/payment-methods. Accepts ?amount=.",
          "rateLimit": "60 req/min"
        },
        "resellerPayment": {
          "description": "Creates payment for reseller plan. Also send reseller_username, reseller_email and reseller_password.",
          "notes": "customer_name/email/cpf refer to the payer (PIX/card holder), not panel login credentials.",
          "rateLimit": "10 req/min"
        },
        "resellerCheckUsername": {
          "description": "Checks reseller username availability.",
          "rateLimit": "30 req/min"
        },
        "resellerCheckEmail": {
          "description": "Checks reseller email availability.",
          "rateLimit": "30 req/min"
        }
      },
      "renewal": {
        "renewalSearch": {
          "description": "Finds account by username or V2Ray UUID.",
          "rateLimit": "20 req/min"
        },
        "renewalPlans": {
          "description": "Renewal plans for the found account.",
          "rateLimit": "60 req/min"
        },
        "renewalPaymentMethods": {
          "description": "Account seller methods. Query: seller_id (required), amount (optional).",
          "rateLimit": "60 req/min"
        },
        "renewalPayment": {
          "description": "Renews account from /renewal/search. Send account_id, plan_id, gateway_id and payer data.",
          "rateLimit": "10 req/min"
        }
      },
      "publicTest": {
        "testConfig": {
          "description": "Trial page config (duration, cooldown, V2Ray).",
          "rateLimit": "30 req/min"
        },
        "testCreate": {
          "description": "Creates a test account. Credentials are email-only (never in the response).",
          "rateLimit": "5 req/min"
        },
        "testCreateDirect": {
          "description": "Creates a test account and returns credentials in JSON. X-Public-Api-Token from slug owner only. Token cooldown applies.",
          "rateLimit": "5 req/min"
        }
      },
      "credentialRecovery": {
        "recoveryConfig": {
          "description": "Public recovery status (enabled, cooldown, SMTP).",
          "rateLimit": "30 req/min"
        },
        "recoveryRequest": {
          "description": "Resends all VPN credentials linked to the given email. Returns 404 if no accounts exist.",
          "rateLimit": "5 req/min"
        }
      },
      "payment": {
        "paymentStatus": {
          "description": "Status by payment_id (MP/Asaas ID) or order_id. If approved + account, returns credentials. provisioning:true = approved but account still being created on servers.",
          "rateLimit": "60 req/min"
        },
        "paymentCancel": {
          "description": "Cancels payment with pending status (PIX, card or unpaid cash).",
          "rateLimit": "20 req/min"
        }
      },
      "checkuser": {
        "dtunnel": {
          "description": "DTunnel CheckUser — user validation and device limit.",
          "rateLimit": "60 req/min"
        },
        "conecta4g": {
          "description": "Conecta4G CheckUser — POST with app credentials.",
          "rateLimit": "60 req/min"
        }
      }
    },
    "downloadPostman": "Download Postman collection",
    "postmanDescription": "Veltrix Panel collection. Variables: public_api_token, sales_slug, api_base_url. Body examples default to PIX; see docs for card and cash."
  },
  "smtp": {
    "titleGlobal": "Panel SMTP",
    "titleUser": "Reseller SMTP",
    "enable": "Use own SMTP",
    "helpGlobal": "Default panel SMTP. Resellers can override theirs in Automations.",
    "helpUser": "Optional. If off, your reseller emails use the panel SMTP.",
    "host": "Host",
    "hostPlaceholder": "smtp.gmail.com",
    "port": "Port",
    "encryption": "Encryption",
    "encryptionNone": "None",
    "username": "Username",
    "password": "Password",
    "passwordKeep": "Leave blank to keep current",
    "passwordPlaceholder": "Password or app password",
    "fromEmail": "From email",
    "fromName": "From name",
    "testEmail": "Test email",
    "testEmailPlaceholder": "destination{'@'}example.com",
    "testEmailHelp": "Optional. If empty, uses the from email. The test uses form data (no need to save first).",
    "usingGlobalFallback": "Own SMTP off or incomplete — emails use the panel SMTP.",
    "save": "Save SMTP",
    "testing": "Sending...",
    "test": "Send test email",
    "saved": "SMTP saved",
    "saveError": "Failed to save SMTP",
    "loadError": "Failed to load SMTP",
    "testOk": "Test email sent",
    "testFail": "Test email failed"
  },
  "publicApi": {
    "title": "Public API token",
    "help": "One token per account (admin or reseller). Use on external servers with X-Public-Api-Token. Valid for /api/public/* routes with your slug. The PWA uses a cookie session — never embed this token in frontend code.",
    "activePrefix": "Active token:",
    "lastUsed": "Last used: {date}",
    "copyNow": "Copy the token now — it will not be shown again.",
    "headerHint": "Send on every request: {header}: <your_token>",
    "copyHeader": "Copy header",
    "scopeHint": "This token only works with your account slug: {slug}",
    "generate": "Generate token",
    "regenerate": "Regenerate token",
    "revoke": "Revoke token",
    "regenerateConfirm": "Regenerating invalidates the current token. Continue?",
    "revokeConfirm": "Revoke the token? External integrations will stop working.",
    "loadError": "Failed to load token",
    "generateError": "Failed to generate token",
    "revokeError": "Failed to revoke token",
    "generated": "Token generated",
    "revoked": "Token revoked"
  },
  "credentialRecovery": {
    "title": "Recover credentials",
    "subtitle": "Enter the email registered on purchase or trial to receive your VPN credentials",
    "emailLabel": "Email",
    "emailPlaceholder": "you{'@'}email.com",
    "help": "We will send all accounts linked to this email with username, password, status and validity. {cooldown}h cooldown per email.",
    "submit": "Send credentials by email",
    "sending": "Sending...",
    "successTitle": "Credentials sent",
    "emailSentTo": "We sent the credentials to {email}",
    "multipleAccountsSent": "{count} accounts were included in the same email.",
    "checkSpamHint": "Check your inbox and spam folder.",
    "disabled": "Credential recovery is disabled at the moment.",
    "smtpUnavailable": "Email delivery unavailable. Configure panel SMTP.",
    "loadError": "Failed to load page",
    "emailRequired": "Email is required",
    "notFound": "No VPN account found for this email.",
    "submitError": "Could not process the request",
    "cooldownActive": "Wait {hours}h before requesting again for this email"
  }
}
